(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1219-Amazon-Variation"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__avenueAmazonStandardV2) return;
  window.__avenueAmazonStandardV2 = true;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const normalize = value => String(value || '').trim().replace(/\s+/g,' ').toLowerCase();
  const personalized = item => /personalized|personalised|customized|customised/i.test(item.title || '');
  const tagged = (item, tag) => (item.tags || []).includes(tag);
  const compact = item => ({id:item.id,url:item.url,title:item.title,label:item.label,type:item.type,vendor:item.vendor,tags:item.tags,available:item.available,image:item.image,price:item.price,railOptions:item.railOptions});
  class AvenueStudio {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-av-config]').textContent);
      this.initial = JSON.parse(root.querySelector('[data-av-initial]').textContent);
      this.current = this.initial;
      this.slots = [this.current];
      this.active = 0;
      this.quantity = this.current.variant?.min || 1;
      this.cache = new Map();
      this.excluded = new Set([...(this.config.excluded || []), ...(this.config.familyExcluded || [])].map(String));
      this.colorNames = [...new Set(['color','colour','colors','colours',...String(this.config.colorNames || '').split(/[,\n]/).map(normalize).filter(Boolean)])];
      this.swatches = new Map(String(this.config.swatches || '').split('\n').map(line => {
        const i = line.indexOf(':');
        return [normalize(line.slice(0,i)), line.slice(i+1).trim()];
      }));
      this.colorGroups = new Map();
      const groups = [...(this.config.colorGroups || [])].sort((a,b)=>Number(!!a.scope)-Number(!!b.scope));
      for (const group of groups) {
        if (!group.name) continue;
        const key = normalize(group.name).replace(/[\s_-]+/g,'');
        for (const alias of [group.name,...String(group.aliases || '').split(/[,\n]/)]) {
          const name = normalize(alias).replace(/[\s_-]+/g,'');
          if (name) this.colorGroups.set(name,{...group,key});
        }
      }
      this.colorIntent = this.actualColor();
      this.visibleCount = 24;
      this.colors = [];
      this.products = this.config.source === 'manual' ? this.filter(this.config.manual) : this.filter([compact(this.initial)]);
      this.next = this.config.source === 'collection' ? this.config.collection : null;
      this.loading = false;
      this.cartBusy = false;
      this.checkoutBusy = false;
      this.checkoutItems = null;
      this.uncertain = false;
      this.alive = true;
      this.currency = new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency});
      this.events = new AbortController();
      root.addEventListener('click', event => this.click(event), {signal:this.events.signal});
      root.addEventListener('change', event => this.change(event), {signal:this.events.signal});
      this.$('[data-av-cart]').addEventListener('click', event => {
        if (event.target === this.$('[data-av-cart]')) this.closeCart();
      }, {signal:this.events.signal});
      this.$('[data-av-cart]').addEventListener('close', () => {const target=this.lastFocus; this.lastFocus=null; target?.focus({preventScroll:true});}, {signal:this.events.signal});
      this.rebuildColors();
      this.render();
      this.renderRail();
      this.initRelated();
      if (this.next) this.loadMore(true);
      const dock = this.$('[data-av-sticky]');
      if (dock && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {dock.hidden = entries[0].isIntersecting;}, {threshold:0});
        this.observer.observe(this.$('[data-av-main-actions]'));
      } else if (dock) dock.hidden = false;
      if (this.config.offer.enabled) this.offerTimer = setInterval(() => this.renderOffer(), 30000);
    }
    $(selector) {return this.root.querySelector(selector);}
    $$(selector) {return [...this.root.querySelectorAll(selector)];}
    t(key, values = {}) {
      let value = this.config.strings[key] || key;
      for (const [name, replacement] of Object.entries(values)) value = value.replaceAll(`[${name}]`, String(replacement));
      return value;
    }
    money(amount, currency) {
      return currency && currency !== this.config.currency ? new Intl.NumberFormat(this.config.locale,{style:'currency',currency}).format(Number(amount)/100) : this.currency.format(Number(amount)/100);
    }
    url(path) {
      const url = new URL(path, location.origin);
      if (url.origin !== location.origin) throw new Error(this.t('product_error'));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    }
    async get(url, json = false) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, {credentials:'same-origin', signal:controller.signal, headers:{Accept:json?'application/json':'text/html'}});
        if (!response.ok) throw new Error(this.t('product_error'));
        return json ? await response.json() : await response.text();
      } finally {clearTimeout(timer);}
    }
    payload(html) {
      const doc = new DOMParser().parseFromString(html,'text/html');
      const node = doc.querySelector('[data-av-payload]');
      if (!node) throw new Error(this.t('product_error'));
      return JSON.parse(node.textContent);
    }
    async product(path, optionIds = []) {
      const url = this.url(path);
      url.searchParams.delete('variant');
      url.searchParams.delete('option_values');
      url.searchParams.set('section_id','1219-product-studio-single');
      if (optionIds.length) url.searchParams.set('option_values',optionIds.join(','));
      const key = url.href;
      if (this.cache.has(key)) return this.cache.get(key);
      const data = this.payload(await this.get(key)).product;
      if (!data?.id) throw new Error(this.t('product_error'));
      if (this.cache.size >= 40) this.cache.delete(this.cache.keys().next().value);
      this.cache.set(key,data);
      return data;
    }
    filter(items) {
      return (items || []).filter(item => !this.excluded.has(String(item.id)) && !(this.config.excludePersonalized && personalized(item)) && !(this.config.hideSoldOut && !item.available));
    }
    async loadMore(first = false) {
      if (!this.next || this.railBusy || !this.alive) return;
      this.railBusy = true;
      this.$('[data-av-more]').disabled = true;
      this.$('[data-av-rail-status]').textContent = this.t('loading');
      let succeeded = false;
      try {
        const url = this.url(this.next);
        url.searchParams.set('section_id','1219-product-studio-single');
        const data = this.payload(await this.get(url.href));
        if (!this.alive) return;
        const all = first ? data.products : [...this.products,...data.products];
        this.products = this.filter([...new Map(all.map(item => [String(item.id),item])).values()]);
        this.next = data.next || null;
        this.rebuildColors();
        this.renderOptions();
        this.renderRail();
        this.renderActions();
        succeeded = true;
      } catch (_) {
        if (this.alive) {
          this.$('[data-av-rail-status]').textContent = this.t('load_error');
          this.$('[data-av-more]').hidden = false;
        }
      } finally {
        this.railBusy = false;
        if (this.alive) this.$('[data-av-more]').disabled = false;
      }
      if (succeeded && this.next && this.alive) this.catalogTimer = setTimeout(()=>this.loadMore(),180);
    }
    async revealMore() {
      this.visibleCount += 24;
      if (this.products.length < this.visibleCount && this.next && !this.railBusy) await this.loadMore();
      if (this.alive) this.renderRail();
    }
    actualColor() {
      const option = this.current.options.find(option=>this.optionKey(option.name)==='__color__');
      return option?.values.find(value=>value.selected)?.name || null;
    }
    groupFor(name) {return this.colorGroups.get(normalize(name).replace(/[\s_-]+/g,''));}
    colorKey(name) {return this.groupFor(name)?.key || normalize(name).replace(/[\s_-]+/g,'');}
    colorValue(name) {
      const option = this.current.options.find(option=>this.optionKey(option.name)==='__color__');
      const values = (option?.values || []).filter(value=>this.colorKey(value.name)===this.colorKey(name));
      return values.find(value=>value.selected) || values.find(value=>value.available) || values[0];
    }
    colorMissing() {return !!(this.colorIntent && !this.colorValue(this.colorIntent));}
    rebuildColors() {
      const colors = new Map();
      for (const item of [compact(this.current),...this.products]) {
        for (const option of item.railOptions || []) {
          if (this.optionKey(option.name)!=='__color__') continue;
          for (const value of option.values) {
            const key=this.colorKey(value.name), group=this.groupFor(value.name);
            if (!colors.has(key)) colors.set(key,{...value,key,display:group?.name || value.name});
          }
        }
      }
      this.colors = [...colors.values()];
    }
    async selectColor(name) {
      if (this.loading || this.cartBusy || this.checkoutBusy) return;
      const value = this.colorValue(name);
      if (!value || value.selected) {
        this.colorIntent = value?.name || name;
        this.message('');
        this.render(true);
        this.updateRail();
        return;
      }
      const option=this.current.options.find(option=>this.optionKey(option.name)==='__color__');
      await this.switchOption(value.id,option.position);
    }
    printName(item) {
      if (item.label && item.label !== item.title) return item.label;
      const title = String(item.title || '').trim();
      const parts = title.split(/\s*\|\s*/).filter(Boolean);
      const chosen = Number(this.config.railLabelPart) || 0;
      if (chosen && parts[chosen-1]) return parts[chosen-1];
      const match = /\bprint\b/i.exec(title);
      if (match) {
        const before = title.slice(0,match.index).trim();
        const segments = before.split(/\s*\|\s*|\s+[—–-]\s+|\s*:\s*/).filter(Boolean);
        let name = segments[segments.length-1] || '';
        const prefixes = [item.vendor,item.type,this.config.familyTitle,...String(this.config.printPrefixes || '').split(/\n/)].filter(Boolean).sort((a,b)=>b.length-a.length);
        for (let pass=0;pass<2;pass++) {
          for (const prefix of prefixes) {
            const clean=String(prefix).trim();
            if (normalize(name).startsWith(normalize(clean)) && /^[\s:|—–-]/.test(name.slice(clean.length))) name=name.slice(clean.length).replace(/^[\s:|—–-]+/,'');
          }
        }
        if (name) return name;
      }
      const spec = value => /(?:\d+\s*(?:ml|ltr?|litres?|liters?|hours?|hrs?|oz)\b|\d+\s*%|leak[ -]?proof|double[ -]?wall|insulat|colou?rs?\s*options?|hot\s*(?:&|and)\s*cold)/i.test(value);
      if (parts.length > 1) return parts.slice(1).find(part => !spec(part)) || this.config.railPlainLabel || title;
      const dashParts = title.split(/\s+[—–-]\s+/).filter(Boolean);
      return dashParts.length > 1 ? dashParts[dashParts.length-1] : title;
    }
    optionKey(name) {
      const key=normalize(name);
      const label=key.replace(/[_-]+/g,' ').replace(/[:*]+$/g,'').trim();
      const colorLabel=/^(?:(?:please\s+)?(?:select|choose|pick)(?:\s+(?:a|the|your))?\s+|shop\s+by\s+)?colou?rs?(?:\s+(?:options?|variants?))?$/.test(label);
      return this.colorNames.includes(key) || colorLabel ? '__color__' : key;
    }
    valueKey(name,value) {return this.optionKey(name)==='__color__' ? this.colorKey(value) : normalize(value);}
    selectedColor() {return this.config.railSync===false ? null : this.colorIntent;}
    railPreview(item) {
      const color = this.selectedColor();
      const option = (item.railOptions || []).find(option => this.optionKey(option.name)==='__color__');
      if (!color) return {image:item.image,note:'',unavailable:!item.available};
      const values = (option?.values || []).filter(value => this.colorKey(value.name)===this.colorKey(color));
      const value = values.find(value => normalize(value.name)===normalize(color)) || values.find(value => value.available!==false && value.image) || values.find(value => value.available!==false) || values.find(value => value.image) || values[0];
      if (!value) return {image:null,note:this.t('rail_color_missing',{color}),unavailable:true};
      return {image:value.image,note:value.available===false?this.t('sold_out'):value.image?'':this.t('rail_photo_missing'),unavailable:value.available===false};
    }
    updateRail() {
      const currentIndex = this.products.findIndex(item => String(item.id)===String(this.current.id));
      if (currentIndex !== -1) this.products[currentIndex]=compact(this.current);
      const color = this.selectedColor();
      const resolution = Math.max(360,Math.min(960,Number(this.config.railResolution) || 720));
      const sizes = `(max-width: 749px) ${Number(this.config.railMobile)||72}px, ${Number(this.config.railDesktop)||88}px`;
      const nodes = new Map(this.$$('[data-av-design]').map(node => [node.dataset.avDesign,node]));
      this.products.slice(0,this.visibleCount).forEach(item => {
        const node = nodes.get(String(item.id));
        if (!node) return;
        const label = this.printName(item);
        const colorLabel = (item.railOptions || []).some(option => this.optionKey(option.name)==='__color__') ? color : null;
        const preview = this.railPreview(item);
        node.dataset.avUnavailable=String(!!preview.unavailable);
        node.disabled=!!(preview.unavailable || this.loading || this.cartBusy || this.checkoutBusy);
        const note = preview.note || (!item.available ? this.t('sold_out') : '');
        const image = node.querySelector('img');
        node.setAttribute('aria-pressed',String(item.id)===String(this.current.id)?'true':'false');
        node.setAttribute('aria-label',[label,colorLabel,note].filter(Boolean).join(' · '));
        node.title = [label,note].filter(Boolean).join(' · ');
        node.querySelector('.av-design-label').textContent=label;
        const detail = node.querySelector('[data-av-rail-note]');
        detail.textContent=note;
        detail.hidden=!note;
        image.hidden=!preview.image;
        node.querySelector('.av-design-placeholder').hidden=!!preview.image;
        if (preview.image) {
          const src=this.imageUrl(preview.image,resolution);
          const srcset=[180,240,360,540,720,960].filter(width => width<=resolution).map(width => `${this.imageUrl(preview.image,width)} ${width}w`).join(',');
          if (image.sizes!==sizes) image.sizes=sizes;
          if (image.srcset!==srcset) image.srcset=srcset;
          if (image.getAttribute('src')!==src) image.src=src;
          image.alt=[label,colorLabel].filter(Boolean).join(' · ');
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('src');
          image.alt='';
        }
      });
    }
    renderRail() {
      const rail = this.$('[data-av-rail]');
      const offset = rail.scrollLeft;
      const nodes = new Map(this.$$('[data-av-design]').map(node => [node.dataset.avDesign,node]));
      const allowed = new Set(this.products.slice(0,this.visibleCount).map(item => String(item.id)));
      nodes.forEach((node,id) => {if (!allowed.has(id)) node.remove();});
      this.products.slice(0,this.visibleCount).forEach(item => {
        if (!nodes.has(String(item.id))) rail.insertAdjacentHTML('beforeend',`<button data-gokwik-processed="true" type="button" class="av-design" data-av-design="${esc(item.id)}"><span class="av-design-media"><img width="360" height="450" loading="lazy" decoding="async" alt="" hidden><span class="av-design-placeholder" aria-hidden="true">◇</span></span><span class="av-design-label"></span><small data-av-rail-note hidden></small></button>`);
      });
      this.updateRail();
      rail.scrollLeft = offset;
      this.$('[data-av-design-zone]').hidden = this.config.source!=='manual' && !this.config.collection;
      this.railObserver?.disconnect();
      if (this.config.autoLoad && this.products.length>=this.visibleCount && 'IntersectionObserver' in window && (this.next || this.products.length>this.visibleCount)) {
        this.railObserver = new IntersectionObserver(entries=>{
          if (entries.some(entry=>entry.isIntersecting)) this.revealMore();
        },{root:rail,rootMargin:'0px 180px'});
        const last=rail.lastElementChild;
        if(last) this.railObserver.observe(last);
      }
      this.$('[data-av-more]').hidden = !(this.next || this.products.length>this.visibleCount);
      this.$('[data-av-rail-status]').textContent = !this.products.length ? this.t('no_designs') : this.next ? this.t('remaining') : '';
      this.renderActions();
    }
    initRelated() {
      const section=this.$('[data-av-related-section]'),rail=this.$('[data-av-related-rail]');
      if(!section || !rail) return;
      this.relatedFallback=rail.innerHTML;
      this.relatedCache=new Map();
      const signal=this.events.signal;
      const arrows=()=>this.relatedArrows();
      rail.addEventListener('scroll',arrows,{passive:true,signal});
      if('ResizeObserver' in window){this.relatedResize=new ResizeObserver(arrows);this.relatedResize.observe(rail);}
      rail.addEventListener('dragstart',event=>event.preventDefault(),{signal});
      rail.addEventListener('pointerdown',event=>{
        if(event.pointerType!=='mouse'||event.button!==0) return;
        this.relatedDrag={id:event.pointerId,x:event.clientX,y:event.clientY,left:rail.scrollLeft,moved:false};this.relatedDragUntil=0;
      },{signal});
      rail.addEventListener('pointermove',event=>{
        const drag=this.relatedDrag;if(!drag||drag.id!==event.pointerId) return;
        const delta=event.clientX-drag.x;
        if(!drag.moved && Math.abs(delta)>6 && Math.abs(delta)>Math.abs(event.clientY-drag.y)){
          drag.moved=true;rail.setPointerCapture(event.pointerId);rail.classList.add('av-dragging');
        }
        if(drag.moved){event.preventDefault();rail.scrollLeft=drag.left-delta;}
      },{signal});
      const finish=event=>{
        const drag=this.relatedDrag;if(!drag||drag.id!==event.pointerId) return;
        if(drag.moved)this.relatedDragUntil=performance.now()+350;
        this.relatedDrag=null;rail.classList.remove('av-dragging');
        if(rail.hasPointerCapture(event.pointerId))rail.releasePointerCapture(event.pointerId);
      };
      window.addEventListener('pointerup',finish,{signal});window.addEventListener('pointercancel',finish,{signal});
      rail.addEventListener('click',event=>{if(event.detail && performance.now()<this.relatedDragUntil){event.preventDefault();event.stopImmediatePropagation();}},{capture:true,signal});
      if(section.dataset.source==='automatic'){
        const start=()=>{this.relatedReady=true;this.relatedObserver?.disconnect();this.loadRelated();};
        if('IntersectionObserver' in window){this.relatedObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting))start();},{rootMargin:'300px'});this.relatedObserver.observe(section);}
        else start();
      }
      this.updateRelated();
    }
    relatedArrows() {
      const rail=this.$('[data-av-related-rail]');if(!rail)return;
      const overflow=rail.scrollWidth-rail.clientWidth;
      this.$$('[data-av-related-scroll]').forEach(button=>{button.hidden=overflow<2;button.disabled=Number(button.dataset.avRelatedScroll)<0?rail.scrollLeft<=1:rail.scrollLeft>=overflow-1;});
    }
    updateRelated() {
      const section=this.$('[data-av-related-section]');if(!section)return;
      if(section.dataset.source==='automatic' && this.relatedReady && this.relatedFor!==String(this.current.id)){this.loadRelated();return;}
      const limit=Number(section.dataset.limit)||6;let shown=0;
      this.$$('[data-av-related]').forEach(card=>{card.hidden=card.dataset.avRelated===String(this.current.id)||shown>=limit;if(!card.hidden)shown++;});
      section.hidden=!shown && !(section.dataset.source==='automatic' && !this.relatedReady);
      this.relatedArrows();
    }
    async loadRelated() {
      const section=this.$('[data-av-related-section]'),rail=this.$('[data-av-related-rail]');
      if(!section||!this.relatedReady)return;
      const id=String(this.current.id);if(this.relatedFor===id)return;
      this.relatedFor=id;const ticket=this.relatedTicket=(this.relatedTicket||0)+1;
      const status=this.$('[data-av-related-status]');
      section.hidden=false;rail.setAttribute('aria-busy','true');status.hidden=false;status.textContent=this.t('loading');
      try{
        let products=this.relatedCache.get(id);
        if(!products){
          const url=this.url(section.dataset.recommendationsUrl);
          url.searchParams.set('product_id',id);url.searchParams.set('limit',String(Math.min(10,Number(section.dataset.limit)||6)));url.searchParams.set('intent','related');
          const data=await this.get(url.href,true);products=Array.isArray(data.products)?data.products:[];
          if(this.relatedCache.size>=20)this.relatedCache.delete(this.relatedCache.keys().next().value);
          this.relatedCache.set(id,products);
        }
        if(!this.alive||this.relatedTicket!==ticket)return;
        const cards=products.filter(item=>String(item.id)!==id).slice(0,Number(section.dataset.limit)||6).map(item=>{
          const photo=item.featured_image||item.images?.[0],url=typeof photo==='string'?photo:photo?.src||photo?.url;
          const media=url?`<img src="${esc(this.imageUrl(url,420))}" srcset="${esc(this.imageUrl(url,200))} 200w, ${esc(this.imageUrl(url,420))} 420w" sizes="(max-width: 749px) 155px, 200px" width="420" height="525" alt="${esc(item.title)}" loading="lazy" decoding="async" draggable="false">`:'<span class="av-related-placeholder" aria-hidden="true">◇</span>';
          return `<a class="av-related-card" data-av-related="${esc(item.id)}" href="${esc(this.url(item.url).href)}" draggable="false">${media}<h3>${esc(item.title)}</h3><span>${esc(this.money(item.price))}</span></a>`;
        }).join('');
        rail.innerHTML=cards||this.relatedFallback;
      }catch(_){if(this.alive&&this.relatedTicket===ticket)rail.innerHTML=this.relatedFallback;}
      finally{if(this.alive&&this.relatedTicket===ticket){rail.setAttribute('aria-busy','false');status.hidden=true;rail.scrollLeft=0;this.updateRelated();}}
    }
    selectedValues(product = this.current) {return product.options.map(option => option.values.find(value => value.selected) || option.values[0]);}
    async switchProduct(path) {
      if (this.loading || this.cartBusy || this.checkoutBusy) return;
      this.loading = true;
      this.message(this.t('loading'));
      this.renderActions();
      try {
        const old = new Map(this.current.options.map(option => [this.optionKey(option.name),this.valueKey(option.name,option.values.find(value => value.selected)?.name)]));
        if (this.colorIntent) old.set('__color__',this.colorKey(this.colorIntent));
        let data = await this.product(path);
        if (this.colorIntent && !data.options.some(option=>this.optionKey(option.name)==='__color__' && option.values.some(value=>this.colorKey(value.name)===this.colorKey(this.colorIntent)))) throw new Error(this.t('rail_color_missing',{color:this.colorIntent}));
        const wanted = data.options.map(option => option.values.find(value => this.valueKey(option.name,value.name) === old.get(this.optionKey(option.name))) || option.values.find(value => value.selected) || option.values[0]);
        if (wanted.some(value => !value.selected)) data = await this.product(data.url,wanted.map(value => value.id));
        if (!this.alive) return;
        if (this.filter([compact(data)]).length === 0) throw new Error(this.t('unavailable'));
        this.current = data;
        this.colorIntent = this.actualColor();
        this.rebuildColors();
        this.slots[this.active] = data;
        this.quantity = Math.max(this.quantity, data.variant?.min || 1);
        this.message('');
        this.render();
        this.renderRail();
      } catch (error) {this.message(error.message || this.t('product_error'),true);}
      finally {this.loading = false; if(this.alive) this.renderActions();}
    }
    async switchOption(id, position) {
      if (this.loading || this.cartBusy || this.checkoutBusy) return;
      const option = this.current.options.find(item => item.position === position);
      const value = option?.values.find(item => item.id === id);
      if (!value) return;
      if (value.productUrl && this.url(value.productUrl).pathname !== this.url(this.current.url).pathname) {
        await this.switchProduct(value.productUrl);
        return;
      }
      const selected = this.selectedValues().map((item,index) => index===position-1 ? id : item.id);
      const previousColor = this.colorIntent;
      if (this.optionKey(option.name)==='__color__') this.colorIntent=value.name;
      this.loading = true;
      this.renderOptions();
      this.updateRail();
      this.renderActions();
      this.message(this.t('loading'));
      try {
        const data = await this.product(this.current.url,selected);
        if (!this.alive) return;
        this.current = data;
        if (this.optionKey(option.name)==='__color__') this.colorIntent=this.actualColor();
        this.slots[this.active] = data;
        this.message('');
        this.render(true);
        this.updateRail();
      } catch (error) {
        this.colorIntent=previousColor;
        if (this.alive) {this.renderOptions();this.updateRail();this.message(this.t('product_error'),true);}
      }
      finally {this.loading = false; if(this.alive) {this.renderActions(); this.$(`[data-av-option="${CSS.escape(id)}"]`)?.focus({preventScroll:true});}}
    }
    imageUrl(url, width) {
      const parsed = new URL(url,location.origin);
      if (!['https:','http:'].includes(parsed.protocol)) return '';
      parsed.searchParams.set('width',String(width));
      return parsed.href;
    }
    setImage(node,url,alt,priority = false) {
      if (!node || !url) return;
      const width = priority ? 1400 : 900;
      node.srcset = [400,600,900,width].filter((v,i,a)=>a.indexOf(v)===i).map(size => `${this.imageUrl(url,size)} ${size}w`).join(',');
      node.sizes = '(min-width: 1000px) 50vw, 100vw';
      if (node.getAttribute('src') !== url) node.src = url;
      node.alt = alt || '';
      node.width = width;
      node.height = width;
      node.loading = priority ? 'eager' : 'lazy';
      node.decoding = 'async';
      if (priority) node.fetchPriority = 'high';
    }
    renderGallery() {
      const gallery = this.$('[data-av-hero]');
      const missing=this.colorMissing();
      const note=this.$('[data-av-hero-note]');
      note.hidden=!missing;
      note.textContent=missing?this.t('rail_color_missing',{color:this.colorIntent}):'';
      this.$('[data-av-thumbs]').hidden=missing;
      let img = gallery.querySelector('img');
      if (!img && this.current.hero) {img = document.createElement('img'); gallery.append(img);}
      if (img) {img.hidden = !this.current.hero || missing; this.setImage(img,this.current.hero,this.current.title,true);}
      this.photos = this.current.images || [];
      this.$('[data-av-thumbs]').innerHTML = this.photos.map((photo,index) => `<button data-gokwik-processed="true" type="button" data-av-photo="${index}" aria-label="${esc(photo.alt || this.current.title)}" aria-pressed="${photo.url===this.current.hero}"><img src="${esc(this.imageUrl(photo.url,160))}" width="80" height="80" alt="${esc(photo.alt || this.current.title)}" loading="lazy" decoding="async"></button>`).join('');
    }
    renderOptions() {
      const target = this.$('[data-av-options]');
      const active = target.contains(document.activeElement) ? document.activeElement : null;
      const focusedColor = active?.dataset.avColor, focusedOption = active?.dataset.avOption;
      const regular = this.current.defaultOnly ? [] : this.current.options.filter(option=>this.optionKey(option.name)!=='__color__');
      let html = '';
      if (this.colors.length) {
        html = `<fieldset><legend>${esc(this.t('color'))}</legend><div class="av-values">${this.colors.map(entry=>{
          const group=this.groupFor(entry.name), value=this.colorValue(entry.name);
          const candidate=group?.color || value?.swatch || entry.swatch || this.swatches.get(normalize(value?.name || entry.name)) || entry.name;
          const shade=CSS.supports('color',candidate)?candidate:null;
          const photo=group?.color ? null : value?.swatchImage || entry.swatchImage;
          const unavailable=!value || value.available===false;
          const selectedColor=!!this.colorIntent && entry.key===this.colorKey(this.colorIntent);
          const chip=photo?`<span class="av-color-chip"><img src="${esc(photo)}" width="23" height="23" alt="" loading="lazy"></span>`:`<span class="av-color-chip${shade?'':' av-color-chip--unknown'}"${shade?` style="background:${esc(shade)}"`:''}></span>`;
          return `<button data-gokwik-processed="true" type="button" class="av-option av-color-choice${unavailable?' av-unavailable':''}" data-av-color="${esc(entry.name)}" aria-pressed="${selectedColor}" aria-label="${esc(entry.display)}${unavailable?' · '+esc(this.t('unavailable')):''}" title="${esc(value?.name || entry.name)}" ${group?.attributes || ''}>${chip}<span class="av-color-name">${esc(entry.display)}</span></button>`;
        }).join('')}</div></fieldset>`;
      }
      html += regular.map(option=>`<fieldset><legend>${esc(option.name)} <b>${esc(option.values.find(value=>value.selected)?.name || '')}</b></legend><div class="av-values">${option.values.map(value=>`<button data-gokwik-processed="true" type="button" class="av-option${value.available?'':' av-unavailable'}" data-av-option="${esc(value.id)}" data-position="${option.position}" aria-pressed="${!!value.selected}">${esc(value.name)}</button>`).join('')}</div></fieldset>`).join('');
      target.innerHTML=html;
      if(focusedColor) this.$(`[data-av-color="${CSS.escape(focusedColor)}"]`)?.focus({preventScroll:true});
      else if(focusedOption) this.$(`[data-av-option="${CSS.escape(focusedOption)}"]`)?.focus({preventScroll:true});
    }
    richText(html) {
      const doc = new DOMParser().parseFromString(String(html || ''),'text/html');
      doc.querySelectorAll('script,style,iframe,object,embed,form,link,meta,base').forEach(node=>node.remove());
      doc.body.querySelectorAll('*').forEach(node => [...node.attributes].forEach(attribute => {
        if (/^on/i.test(attribute.name) || (['href','src','action'].includes(attribute.name) && /^\s*(javascript|data):/i.test(attribute.value))) node.removeAttribute(attribute.name);
      }));
      return doc.body.innerHTML;
    }
    details() {
      const value = this.current.details || this.config.familyDetails;
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    }
    renderDetails() {
      const mode = this.current.descriptionMode || this.config.descriptionMode;
      const common = this.current.commonDescription || this.config.familyDescription || this.config.commonDescription;
      this.$('[data-av-description]').innerHTML = this.richText(mode==='common' && common ? common : this.current.description);
      const details = this.details();
      this.$('[data-av-why-heading]').textContent = details.whyTitle || this.config.whyTitle;
      this.$('[data-av-caption]').textContent = details.caption || this.config.caption;
      const photo = this.$('.av-editorial-image');
      this.setImage(photo,this.config.editorialImage || this.current.hero,this.current.title);
      const benefits = Array.isArray(details.benefits) ? details.benefits.slice(0,3) : this.config.familyBenefits?.length ? this.config.familyBenefits : this.config.benefits;
      this.$('[data-av-benefits]').innerHTML = benefits.map(benefit => `<article class="av-benefit" ${this.config.benefits.includes(benefit)?benefit.attributes||'':''}><span class="av-eyebrow">${esc(benefit.eyebrow)}</span><h3>${esc(benefit.heading)}</h3><div class="av-benefit-values">${benefit.value?`<strong>${esc(benefit.value)}</strong>`:''}${benefit.secondValue?`<strong>${esc(benefit.secondValue)}</strong>`:''}</div><p>${esc(benefit.text)}</p></article>`).join('');
      const standards = Array.isArray(details.standards) ? details.standards : this.config.standards;
      const applicable = standards.filter(standard => standard.enabled !== false && (!standard.tag || tagged(this.current,standard.tag)));
      this.$('[data-av-standards]').hidden = !applicable.length;
      this.$('.av-assurance-grid').classList.toggle('av-no-standards',!applicable.length);
      this.$('[data-av-standards]').innerHTML = applicable.map(standard => {
        let link = '';
        try {const url = new URL(standard.link,location.origin); if (standard.link && ['https:','http:'].includes(url.protocol)) link=url.href;} catch (_) {}
        return `<div class="av-standard" ${this.config.standards.includes(standard)?standard.attributes||'':''}><span class="av-mark">${esc(standard.mark)}</span><div><strong>${link?`<a href="${esc(link)}">${esc(standard.heading)}</a>`:esc(standard.heading)}</strong><p>${esc(standard.text)}</p></div></div>`;
      }).join('');
    }
    renderOffer() {
      const offer = this.config.offer;
      const now = Date.now();
      const start = offer.start ? Date.parse(offer.start) : -Infinity;
      const end = offer.end ? Date.parse(offer.end) : Infinity;
      const eligible = this.slots.every(item => !tagged(item,'no-cod') && !personalized(item));
      this.$('[data-av-offer]').hidden = !(offer.enabled && offer.code && eligible && now>=start && now<=end);
    }
    renderBundles() {
      if (!this.config.bundles) return;
      const count = this.slots.length;
      this.$('[data-av-tiers]').innerHTML = [1,2,3].map(n => {
        const percent = n===2 ? this.config.discountTwo : n===3 ? this.config.discountThree : 0;
        return `<button data-gokwik-processed="true" type="button" data-av-tier="${n}" aria-pressed="${count===n}"><b>${esc(this.t('buy_count',{count:n}))}</b><span>${esc(percent && this.config.discountsReady ? this.t('bundle_offer',{percent}) : this.t('no_offer'))}</span></button>`;
      }).join('');
      this.$('[data-av-slots]').innerHTML = count>1 ? this.slots.map((item,index) => `<button data-gokwik-processed="true" type="button" data-av-slot="${index}" aria-pressed="${this.active===index}"><b>${esc(this.t('piece',{count:index+1}))}</b><span>${esc(item.label)}</span><small>${esc(item.defaultOnly?'':item.variant?.title || this.t('unavailable'))}</small></button>`).join('') : '';
      this.$('[data-av-bundle-hint]').hidden = count===1;
      this.$('[data-av-bundle-notice]').hidden = count===1;
      this.$('[data-av-editing]').hidden = count===1;
      this.$('[data-av-editing]').textContent = this.t('editing_piece',{count:this.active+1});
    }
    items() {
      const map = new Map();
      this.slots.forEach(item => {
        if (!item.variant) return;
        const id = item.variant.id;
        const quantity = this.slots.length===1 ? this.quantity : 1;
        map.set(id,{id,quantity:(map.get(id)?.quantity || 0)+quantity});
      });
      return [...map.values()];
    }
    purchaseError() {
      if (this.colorMissing()) return this.t('rail_color_missing',{color:this.colorIntent});
      if (this.slots.some(item=>item.requiresSellingPlan)) return this.t('subscription');
      if (this.slots.some(item=>!item.variant)) return this.t('unavailable');
      if (this.slots.some(item=>!item.variant.available)) return this.t(this.slots.length>1?'bundle_unavailable':'out_of_stock');
      for (const line of this.items()) {
        const variant = this.slots.find(item=>item.variant?.id===line.id).variant;
        const min = variant.min || 1, step=variant.step || 1;
        if (!Number.isInteger(line.quantity) || line.quantity<min || line.quantity%step!==0 || (variant.max && line.quantity>variant.max)) return this.t('quantity_rule',{min,step});
      }
      return '';
    }
    total() {return this.slots.reduce((sum,item)=>sum+(item.variant?.price || 0),0)*(this.slots.length===1?this.quantity:1);}
    renderTotals() {
      const amount = this.colorMissing() || this.slots.some(item=>!item.variant) ? '—' : this.money(this.total());
      this.$('[data-av-total]').textContent = amount;
      if (this.$('[data-av-sticky-price]')) this.$('[data-av-sticky-price]').textContent = amount;
      this.$$('[data-av-quantity]').forEach(quantity=>{
        quantity.min = this.current.variant?.min || 1;
        quantity.step = this.current.variant?.step || 1;
        if(this.current.variant?.max) quantity.max=this.current.variant.max; else quantity.removeAttribute('max');
        quantity.value = String(this.quantity);
      });
      this.$$('[data-av-quantity-wrap]').forEach(wrap=>wrap.hidden=this.slots.length>1);
      this.$$('.av-purchase-row').forEach(row=>row.classList.toggle('av-no-quantity',this.slots.length>1));
    }
    renderActions() {
      const error = this.purchaseError();
      const busy = this.loading || this.cartBusy || this.checkoutBusy;
      if(this.checkoutItems && this.checkoutItems!==JSON.stringify(this.items())) this.checkoutItems=null;
      this.root.setAttribute('aria-busy',String(busy));
      this.$$('[data-av-add],[data-av-buy]').forEach(button => {
        button.disabled = !!(error || busy || this.uncertain);
        const label = button.hasAttribute('data-av-add')?'add':this.checkoutItems?'continue_checkout':'buy';
        button.textContent = busy ? this.t('loading') : this.current.variant && !this.current.variant.available ? this.t('sold_out') : this.t(label);
        button.title = error || '';
      });
      this.$$('[data-av-option],[data-av-color],[data-av-design],[data-av-tier],[data-av-slot],[data-av-quantity]').forEach(element=>{element.disabled=busy || element.dataset.avUnavailable==='true';});
      this.$$('[data-av-qty-step]').forEach(button=>{const step=Number(button.dataset.avQtyStep);button.disabled=busy||this.slots.length>1||(step<0?this.quantity<=(this.current.variant?.min||1):!!this.current.variant?.max&&this.quantity>=this.current.variant.max);});
      this.$('[data-av-checkout]').disabled=!!(busy || !this.cart?.items?.length);
      if (error && !busy) this.message(error,true);
    }
    render(variantOnly = false) {
      this.$('[data-av-title]').textContent = this.current.title;
      this.$('[data-av-price]').textContent = this.current.variant && !this.colorMissing() ? this.money(this.current.variant.price) : '—';
      const compare = this.$('[data-av-compare]');
      compare.hidden = this.colorMissing() || !(this.current.variant?.compare > this.current.variant?.price);
      compare.textContent = this.current.variant?.compare ? this.money(this.current.variant.compare) : '';
      this.renderSavings();
      this.updateRelated();
      this.renderGallery();
      this.renderOptions();
      if (!variantOnly) this.renderDetails();
      else this.setImage(this.$('.av-editorial-image'),this.config.editorialImage || this.current.hero,this.current.title);
      this.renderBundles();
      this.renderOffer();
      this.renderTotals();
      this.renderActions();
    }
    renderSavings() {
      const node=this.$('[data-av-savings]');if(!node)return;
      const variant=this.current.variant,amount=Number(variant?.compare)-Number(variant?.price);
      node.hidden=!(variant && !this.colorMissing() && amount>0 && Number(variant.compare)>0);
      if(node.hidden)return;
      const percent=Math.floor(amount/Number(variant.compare)*100);
      node.querySelector('[data-av-savings-percent]').textContent=this.t('discount_percent',{percent});
      node.querySelector('[data-av-savings-amount]').textContent=this.t('save_amount',{amount:this.money(amount)});
      const key=variant.id+':'+amount;
      if(node.dataset.animate==='true'&&key!==this.savingsKey&&!matchMedia('(prefers-reduced-motion: reduce)').matches){node.getAnimations().forEach(animation=>animation.cancel());node.animate([{opacity:.65,transform:'translateY(2px)'},{opacity:1,transform:'translateY(0)'}],{duration:700,iterations:2});}
      this.savingsKey=key;
    }
    message(text,error = false) {
      const node = this.$('[data-av-message]');
      node.textContent = text;
      node.hidden = !text;
      node.classList.toggle('av-error',error);
    }
    async click(event) {
      const button = event.target.closest('button');
      if (!button || !this.root.contains(button)) return;
      if(button.matches('[data-av-add],[data-av-buy],[data-av-checkout]')) {event.preventDefault(); event.stopPropagation();}
      if (button.disabled) return;
      if(button.hasAttribute('data-av-qty-step')){
        if(this.loading||this.cartBusy||this.checkoutBusy||this.slots.length>1)return;
        const v=this.current.variant,min=v?.min||1,step=v?.step||1;
        this.quantity=Math.max(min,Math.min(v?.max||Infinity,(Number.isFinite(this.quantity)?this.quantity:min)+Number(button.dataset.avQtyStep)*step));
        this.message('');this.renderTotals();this.renderActions();
      }else if(button.hasAttribute('data-av-related-scroll')){
        const rail=this.$('[data-av-related-rail]');rail?.scrollBy({left:Number(button.dataset.avRelatedScroll)*rail.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }else if (button.hasAttribute('data-av-color')) await this.selectColor(button.dataset.avColor);
      else if (button.hasAttribute('data-av-design')) {
        const item = this.products.find(item=>String(item.id)===button.dataset.avDesign);
        if(item) await this.switchProduct(item.url);
      } else if (button.hasAttribute('data-av-option')) await this.switchOption(button.dataset.avOption,Number(button.dataset.position));
      else if (button.hasAttribute('data-av-more')) await this.revealMore();
      else if (button.hasAttribute('data-av-scroll')) this.$('[data-av-rail]').scrollBy({left:Number(button.dataset.avScroll)*this.$('[data-av-rail]').clientWidth*0.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      else if (button.hasAttribute('data-av-photo')) {
        const photo = this.photos[Number(button.dataset.avPhoto)];
        if(photo) {this.setImage(this.$('[data-av-hero] img'),photo.url,photo.alt,true); this.$$('[data-av-photo]').forEach(node=>node.setAttribute('aria-pressed',String(node===button)));}
      } else if (button.hasAttribute('data-av-tier')) {
        if(this.loading || this.cartBusy || this.checkoutBusy) return;
        const count = Number(button.dataset.avTier);
        this.slots = Array.from({length:count},(_,index)=>this.slots[index] || this.current);
        this.active = 0;
        this.current = this.slots[0];
        this.colorIntent=this.actualColor();
        this.message(''); this.render(); this.renderRail();
      } else if (button.hasAttribute('data-av-slot')) {
        if(this.loading || this.cartBusy || this.checkoutBusy) return;
        this.active=Number(button.dataset.avSlot); this.current=this.slots[this.active]; this.colorIntent=this.actualColor();
        this.message(''); this.render(); this.renderRail();
      } else if (button.hasAttribute('data-av-copy')) {
        try {await navigator.clipboard.writeText(this.config.offer.code); button.querySelector('span').textContent=this.t('copied');}
        catch (_) {this.message(this.t('copy_error')); const range=document.createRange(); range.selectNodeContents(button.querySelector('b')); const selection=window.getSelection(); selection.removeAllRanges(); selection.addRange(range);}
      } else if (button.hasAttribute('data-av-add')) await this.add(false);
      else if (button.hasAttribute('data-av-buy')) await this.add(true);
      else if (button.hasAttribute('data-av-close')) this.closeCart();
      else if (button.hasAttribute('data-av-checkout')) await this.checkout();
      else if (button.hasAttribute('data-av-remove')) await this.removeItem(button.dataset.avRemove);
    }
    change(event) {
      if(!event.target.matches('[data-av-quantity]') || this.loading || this.cartBusy || this.checkoutBusy) return;
      this.quantity = Number(event.target.value);
      this.message(''); this.renderTotals(); this.renderActions();
    }
    async readCart() {return this.get(this.url(this.config.routes.cart+'.js').href,true);}
    async add(checkout) {
      if (this.cartBusy || this.checkoutBusy || this.loading || this.uncertain || this.purchaseError()) return;
      const selectedItems=JSON.stringify(this.items());
      if(checkout && this.checkoutItems===selectedItems) {await this.checkout(); return;}
      this.checkoutItems=null;
      this.cartBusy=true;
      this.message(this.t('loading_cart'));
      this.$('[data-av-cart-link]').hidden=true;
      this.renderActions();
      let added=false;
      try {
        const payload={items:this.items()};
        if (document.getElementById('cart-icon-bubble')) {payload.sections=['cart-icon-bubble']; payload.sections_url=location.pathname;}
        let response;
        try {response = await fetch(this.url(this.config.routes.add), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});}
        catch (_) {this.uncertain=true; throw new Error(this.t('cart_check'));}
        let data;
        try {data=await response.json();}
        catch (_) {this.uncertain=true; throw new Error(this.t('cart_check'));}
        if(!response.ok) {
          this.cache.clear();
          throw new Error((typeof data.description==='string'?data.description:this.t('cart_error'))+' '+this.t('view_cart'));
        }
        added=true;
        if(checkout) this.checkoutItems=selectedItems;
        this.cart=null;
        this.message(this.t('added'));
        this.updateIcon(data.sections);
        try {
          this.cart=await this.readCart();
          document.dispatchEvent(new CustomEvent('avenue:cart-updated',{detail:{cart:this.cart,source:this.root}}));
        } catch (_) {this.message(this.t('cart_load_error'));}
      } catch(error) {this.message(error.message || this.t('cart_error'),true);}
      finally {
        this.cartBusy=false;
        this.$('[data-av-cart-link]').hidden=false;
        this.renderActions();
        if(added) this.cache.clear();
        if(this.$('[data-av-cart]').open) this.renderCart();
      }
      if(!added || !this.alive) return;
      if(checkout) await this.checkout();
      else if(this.config.cartAction==='cart') location.assign(this.config.routes.cart);
      else if(this.config.cartAction==='drawer' && this.cart) this.openCart();
    }
    updateIcon(sections) {
      const html=sections?.['cart-icon-bubble'];
      const target=document.getElementById('cart-icon-bubble');
      if(!html || !target) return;
      const doc=new DOMParser().parseFromString(html,'text/html');
      const source=doc.querySelector('#cart-icon-bubble') || doc.querySelector('.shopify-section');
      if(source) target.innerHTML=source.innerHTML;
    }
    openCart() {
      const dialog=this.$('[data-av-cart]');
      this.lastFocus=document.activeElement;
      this.renderCart();
      if(!dialog.open) dialog.showModal();
    }
    closeCart(restoreFocus=true) {if(!restoreFocus) this.lastFocus=null; this.$('[data-av-cart]').close();}
    renderCart() {
      if(!this.cart) return;
      const items=this.cart.items || [];
      this.$('[data-av-cart-body]').innerHTML=items.length?items.map(item=>`<article class="av-cart-item">${item.image?`<img src="${esc(this.imageUrl(item.image,160))}" width="80" height="96" alt="${esc(item.product_title)}" loading="lazy">`:''}<div><a href="${esc(item.url)}">${esc(item.product_title)}</a><p>${esc(item.variant_title || '')}</p><p>${esc(this.t('quantity'))}: ${item.quantity}</p><strong>${esc(this.money(item.final_line_price,this.cart.currency))}</strong>${item.original_line_price>item.final_line_price?` <s>${esc(this.money(item.original_line_price,this.cart.currency))}</s>`:''}<button data-gokwik-processed="true" type="button" class="av-text-button" data-av-remove="${esc(item.key)}">${esc(this.t('remove'))}</button></div></article>`).join(''):`<p>${esc(this.t('empty_cart'))}</p>`;
      this.$('[data-av-cart-total]').textContent=this.money(this.cart.total_price,this.cart.currency);
      this.$('[data-av-checkout]').disabled=!items.length || this.cartBusy || this.checkoutBusy;
    }
    async removeItem(key) {
      if(this.cartBusy || this.checkoutBusy) return;
      this.checkoutItems=null;
      this.cartBusy=true;
      this.$$('[data-av-remove],[data-av-checkout]').forEach(button=>{button.disabled=true;});
      const message=this.$('[data-av-cart-message]'); message.hidden=true;
      try {
        const response=await fetch(this.url(this.config.routes.change),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})});
        const data=await response.json();
        if(!response.ok) throw new Error(this.t('cart_remove_error'));
        this.cart=data;
        document.dispatchEvent(new CustomEvent('avenue:cart-updated',{detail:{cart:this.cart,source:this.root}}));
        if(document.getElementById('cart-icon-bubble')) {
          try {const url=this.url(this.config.routes.cart); url.searchParams.set('sections','cart-icon-bubble'); this.updateIcon(await this.get(url.href,true));} catch (_) {}
        }
      } catch (_) {message.hidden=false; message.textContent=this.t('cart_remove_error');}
      finally {this.cartBusy=false; this.renderCart(); this.renderActions();}
    }
    async checkout() {
      if(this.checkoutBusy || this.cartBusy || !this.alive) return;
      if(this.config.checkoutMode==='shopify') {
        const root=this.config.routes.root.replace(/\/$/,'');
        location.assign(root+'/checkout');
        return;
      }
      if(this.config.checkoutMode==='gokwik') {
        this.checkoutBusy=true;
        this.renderActions();
        try {
          this.cart=await this.readCart();
          if(!this.alive) return;
          if(!this.cart.items?.length) {this.checkoutItems=null;throw new Error(this.t('empty_cart'));}
          if(this.checkoutItems && !JSON.parse(this.checkoutItems).every(wanted=>this.cart.items.reduce((sum,item)=>sum+(String(item.variant_id || item.id)===String(wanted.id)?Number(item.quantity):0),0)>=wanted.quantity)) {
            this.checkoutItems=null;
            throw new Error(this.t('cart_changed'));
          }
          const selector=String(this.config.checkoutSelector || '').trim();
          if(selector) {
            const trigger=[...document.querySelectorAll(selector)].find(element=>!element.closest('[data-av-standard-root]') && element.matches('button,input[type="submit"],a') && !element.disabled && element.getAttribute('aria-disabled')!=='true' && !element.closest('form[action*="/cart/add"]') && element.name!=='add' && (element.dataset.gokwikFunction || element.dataset.function)!=='buyNow');
            if(!trigger) throw new Error(this.t('checkout_missing'));
            this.closeCart(false);
            trigger.click();
          } else {
            const sdk=await this.goKwikSdk();
            if(!this.alive) return;
            if(!sdk || !window.merchantInfo?.mid) throw new Error(this.t('checkout_missing'));
            this.closeCart(false);
            await sdk.initCheckout(window.merchantInfo);
          }
        } catch(error) {
          if(this.alive) {
            const message=error.message===this.t('empty_cart') || error.message===this.t('cart_changed') || error.message===this.t('checkout_missing')?error.message:this.t('checkout_error');
            this.message(message,true);
            if(this.$('[data-av-cart]').open) {const note=this.$('[data-av-cart-message]');note.textContent=message;note.hidden=false;}
          }
        } finally {
          this.checkoutBusy=false;
          if(this.alive) {this.$('[data-av-cart-link]').hidden=false;this.renderActions();}
        }
        return;
      }
      location.assign(this.config.routes.cart);
    }
    async goKwikSdk() {
      const ready=()=>typeof window.gokwikSdk?.initCheckout==='function'?window.gokwikSdk:null;
      if(ready()) return ready();
      await new Promise(resolve=>{
        let timer;
        const finish=()=>{clearTimeout(timer);window.removeEventListener('gokwikLoaded',finish);this.events.signal.removeEventListener('abort',finish);resolve();};
        window.addEventListener('gokwikLoaded',finish,{once:true});
        this.events.signal.addEventListener('abort',finish,{once:true});
        timer=setTimeout(finish,4000);
        if(ready() || !this.alive) finish();
      });
      return ready();
    }
    destroy() {
      this.alive=false;
      this.events.abort();
      this.observer?.disconnect();
      this.railObserver?.disconnect();
      this.relatedObserver?.disconnect();
      this.relatedResize?.disconnect();
      clearTimeout(this.catalogTimer);
      clearInterval(this.offerTimer);
      this.closeCart();
      this.root._avenueStudio=null;
    }
  }
  const init = scope => scope.querySelectorAll('[data-av-standard-root]').forEach(root=>{
    if(root._avenueStudio || !root.querySelector('[data-av-config]')) return;
    try {root._avenueStudio=new AvenueStudio(root);} catch (error) {const message=root.querySelector('[data-av-message]'); if(message){message.hidden=false; message.textContent=JSON.parse(root.querySelector('[data-av-config]').textContent).strings.init_error;}}
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true}); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-av-standard-root]').forEach(root=>root._avenueStudio?.destroy()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1219-banner-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('avenue-banner-slider')) {
  customElements.define('avenue-banner-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.q = s => this.querySelector(s);
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.abort = new AbortController();
      this.copyText = JSON.parse(this.q('[data-copy-text]').textContent);
      this.editor = this.dataset.editor === 'true';
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.running = this.dataset.autoplay === 'true' && !this.motion.matches && !this.editor;
      this.hovered = false;
      this.focused = false;
      this.inView = true;
      this.sequence = 0;
      this.swipeUntil = 0;
      this.current = this.slides.find(s => s.dataset.id === this.dataset.initial) || null;
      this.active = [];
      this.listen = (target, name, handler, extra = {}) => target.addEventListener(name, handler, {signal:this.abort.signal,...extra});
      this.listen(this, 'click', e => this.handleClick(e));
      this.listen(this, 'keydown', e => {
        if (e.target.matches('input,textarea,select')) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();this.stop();this.step(e.key === 'ArrowRight' ? 1 : -1, true);
        }
      });
      this.listen(this, 'mouseenter', () => {this.hovered = true;this.schedule();});
      this.listen(this, 'mouseleave', () => {this.hovered = false;this.schedule();});
      this.listen(this, 'focusin', e => {
        if (!e.target.closest('[data-rotation]')) {this.focused = true;this.stop();}
      });
      this.listen(this, 'focusout', e => {if (!this.contains(e.relatedTarget)) {this.focused=false;this.schedule();}});
      this.listen(document, 'visibilitychange', () => {this.refresh();this.schedule();});
      this.listen(this.motion, 'change', e => {if(e.matches)this.stop();});
      this.listen(document, 'shopify:block:select', e => {
        if (!this.editor) return;
        const slide = this.slides.find(s => s.dataset.id === e.detail.blockId);
        if(slide){this.stop();this.select(slide,true);}
      });
      const stage = this.q('[data-stage]');
      this.listen(stage, 'pointerdown', e => {
        if(e.target.closest('button'))return;
        this.pointer = {x:e.clientX,y:e.clientY,id:e.pointerId};
      });
      this.listen(stage, 'pointercancel', () => {this.pointer=null;});
      this.listen(stage, 'pointerup', e => {
        if(!this.pointer || this.pointer.id!==e.pointerId)return;
        const dx=e.clientX-this.pointer.x,dy=e.clientY-this.pointer.y;this.pointer=null;
        if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)){
          this.swipeUntil=Date.now()+500;this.stop();this.step(dx<0?1:-1,true);
        }
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView=entries[0].isIntersecting;this.schedule();
        },{threshold:0.05});
        this.observer.observe(this);
      }
      this.refresh(true);
    }
    disconnectedCallback() {
      this.abort?.abort();this.observer?.disconnect();
      clearTimeout(this.timer);clearTimeout(this.calendarTimer);clearTimeout(this.preloadTimer);
      this.sequence=(this.sequence||0)+1;this.initialized=false;
    }
    parseDate(text) {
      if(!text.trim())return null;
      const match=text.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/);
      if(!match)return NaN;
      const [,y,m,d,h,mi,se]=match;
      if(+m<1||+m>12||+d<1||+d>new Date(Date.UTC(+y,+m,0)).getUTCDate()||+h>23||+mi>59||+(se||0)>59)return NaN;
      return Date.parse(text.trim());
    }
    eligible(slide,now) {
      if(this.editor)return true;
      if(slide.dataset.enabled!=='true')return false;
      const start=this.parseDate(slide.dataset.start||''),end=this.parseDate(slide.dataset.end||'');
      if(Number.isNaN(start)||Number.isNaN(end))return false;
      if(start!==null && end!==null && end<=start)return false;
      return (start===null||now>=start)&&(end===null||now<end);
    }
    refresh(initial=false) {
      const now=Date.now(),next=this.slides.filter(s=>this.eligible(s,now));
      const changed=next.map(s=>s.dataset.id).join('|')!==this.active.map(s=>s.dataset.id).join('|');
      this.active=next;
      this.hidden=!next.length && !this.editor;
      if(changed||initial){
        this.buildTabs();
        const selected=next.includes(this.current)?this.current:next[0];
        if(selected)this.select(selected,false,initial);
        else {
          this.sequence++;this.current=null;this.slides.forEach(s=>{s.hidden=true;s.inert=true;});
          this.q('[data-navigation]').hidden=true;
          this.q('[data-count]').hidden=true;
          if(this.q('[data-arrows]'))this.q('[data-arrows]').hidden=true;
        }
      }
      clearTimeout(this.calendarTimer);
      if(!this.editor){
        const boundaries=this.slides.flatMap(s=>[this.parseDate(s.dataset.start||''),this.parseDate(s.dataset.end||'')]).filter(n=>Number.isFinite(n)&&n>now);
        if(boundaries.length)this.calendarTimer=setTimeout(()=>this.refresh(),Math.min(60000,Math.max(50,Math.min(...boundaries)-now+25)));
      }
      this.schedule();
    }
    buildTabs() {
      this.q('[data-tabs]').replaceChildren(...this.active.map((slide,i)=>{
        const b=document.createElement('button');b.type='button';b.dataset.go=slide.dataset.id;
        b.setAttribute('aria-controls',slide.id);b.setAttribute('aria-label',this.copyText.banner+' '+(i+1)+': '+slide.dataset.label);
        const number=document.createElement('span');number.className='abs-tab-number';number.textContent=String(i+1).padStart(2,'0');
        const name=document.createElement('span');name.className='abs-tab-label';name.textContent=slide.dataset.label;b.append(number,name);return b;
      }));
      const multiple=this.active.length>1;
      this.q('[data-navigation]').hidden=!multiple;
      this.q('[data-count]').hidden=!multiple;
      if(this.q('[data-arrows]'))this.q('[data-arrows]').hidden=!multiple;
    }
    hydrate(slide) {
      const template=slide?.querySelector('[data-picture]');
      if(template){const media=slide.querySelector('[data-media]');media.append(template.content.cloneNode(true));template.remove();}
      return slide?.querySelector('img');
    }
    async select(slide,announce=false,initial=false) {
      if(!this.active.includes(slide))return;
      const token=++this.sequence,img=this.hydrate(slide);
      if(!initial && img && !img.complete){
        try{await Promise.race([img.decode(),new Promise(resolve=>setTimeout(resolve,1800))]);}catch(_){}
      }
      if(token!==this.sequence||!this.initialized||!this.active.includes(slide))return;
      this.current=slide;
      this.slides.forEach(s=>{s.hidden=s!==slide;s.inert=s!==slide;});
      slide.dataset.reveal=String(!initial&&!this.motion.matches);
      const caption=this.q('[data-caption-host]'),offer=this.q('[data-offer-host]');
      if(caption){caption.replaceChildren(slide.querySelector('[data-caption]').content.cloneNode(true));caption.hidden=!caption.children.length;}
      if(offer){offer.replaceChildren(slide.querySelector('[data-offer]').content.cloneNode(true));offer.hidden=!offer.children.length;}
      this.querySelectorAll('[data-go]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.go===slide.dataset.id)));
      const index=this.active.indexOf(slide)+1;this.q('[data-count]').textContent=index+' / '+this.active.length;
      this.q('[data-status]').textContent=announce?this.copyText.banner+' '+index+' / '+this.active.length+': '+slide.dataset.label:'';
      this.q('[data-copy-manual]').hidden=true;
      clearTimeout(this.preloadTimer);
      if(!this.editor && this.active.length>1 && !navigator.connection?.saveData){
        this.preloadTimer=setTimeout(()=>{if(this.inView&&!document.hidden)this.hydrate(this.active[index%this.active.length]);},1200);
      }
      this.schedule();
    }
    step(delta,announce) {
      if(this.active.length<2)return;
      const i=this.active.indexOf(this.current);this.select(this.active[(i+delta+this.active.length)%this.active.length],announce);
    }
    stop() {this.running=false;this.schedule();}
    schedule() {
      clearTimeout(this.timer);
      const control=this.q('[data-rotation]');if(!control)return;
      control.setAttribute('aria-pressed',String(this.running));control.textContent=this.running?this.copyText.stop:this.copyText.start;
      if(!this.running||this.active.length<2||this.hidden||document.hidden||!this.inView||this.hovered||this.focused)return;
      this.timer=setTimeout(()=>this.step(1,false),Math.max(3000,Number(this.dataset.delay)||6500));
    }
    track(kind) {
      if(this.dataset.tracking!=='true'||this.editor||!this.current)return;
      try{
        if(!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed())return;
        if(!Array.isArray(window.dataLayer))return;
        window.dataLayer.push({event:'avenue_banner_click',banner_id:this.current.dataset.id,banner_name:this.current.dataset.label,banner_position:this.active.indexOf(this.current)+1,banner_action:kind,section_id:this.dataset.section});
      }catch(_){}
    }
    async handleClick(e) {
      const link=e.target.closest('[data-banner-link]');
      if(link){
        if(Date.now()<this.swipeUntil||this.editor){e.preventDefault();return;}
        this.stop();this.track(link.dataset.bannerLink);return;
      }
      const button=e.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-prev')){this.stop();this.step(-1,true);}
      else if(button.hasAttribute('data-next')){this.stop();this.step(1,true);}
      else if(button.dataset.go){this.stop();const slide=this.active.find(s=>s.dataset.id===button.dataset.go);if(slide)this.select(slide,true);}
      else if(button.hasAttribute('data-rotation')){this.running=!this.running;this.focused=false;this.hovered=false;this.schedule();}
      else if(button.hasAttribute('data-copy')){
        this.stop();const selected=this.current,code=button.dataset.copy;
        try{
          await navigator.clipboard.writeText(code);
          if(this.current!==selected||!button.isConnected)return;
          button.querySelector('[data-copy-label]').textContent=this.copyText.copied;
          this.q('[data-status]').textContent=this.copyText.copied+': '+code;
        }catch(_){
          if(this.current!==selected)return;
          const input=this.q('[data-copy-manual]');input.hidden=false;input.value=code;input.focus();input.select();
          this.q('[data-status]').textContent=this.copyText.manual;
        }
        this.track('copy_code');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1219-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', class BundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.discount = Number(this.dataset.discount) || 0;
        this.currency = this.dataset.currency || 'INR';
        this.locale = this.dataset.locale || 'en-IN';
        this.addButton = this.querySelector('[data-add-bundle]');
        this.addText = this.querySelector('[data-add-text]');
        this.status = this.querySelector('[data-status]');
        this.viewCart = this.querySelector('[data-view-cart]');
        this.state = {};

        ['one', 'two'].forEach((group) => {
          const selected = this.querySelector(`[data-choice][data-group="${group}"].is-selected`);
          if (selected) this.state[group] = this.choiceData(selected);
        });

        this.querySelectorAll('[data-choice]').forEach((choice) => {
          choice.addEventListener('click', () => this.selectChoice(choice));
        });

        this.addButton.addEventListener('click', () => this.addBundle());
        this.updatePricing();
      }

      choiceData(choice) {
        return {
          variantId: Number(choice.dataset.variantId),
          productId: choice.dataset.productId,
          productTitle: choice.dataset.productTitle,
          name: choice.dataset.name,
          price: Number(choice.dataset.price),
          compareAt: Number(choice.dataset.compareAtPrice) || Number(choice.dataset.price),
          image: choice.dataset.image,
          alt: choice.dataset.alt
        };
      }

      selectChoice(choice) {
        const group = choice.dataset.group;
        this.querySelectorAll(`[data-choice][data-group="${group}"]`).forEach((item) => {
          const isSelected = item === choice;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-pressed', String(isSelected));
        });

        this.state[group] = this.choiceData(choice);
        this.updateSelection(group);
        this.resetAddedState();
      }

      updateSelection(group) {
        const selected = this.state[group];
        const card = this.querySelector(`[data-main-card="${group}"]`);
        const mainImage = card.querySelector('.bbundle__main-image');
        const summaryImage = this.querySelectorAll('.bbundle__summary-image')[group === 'one' ? 0 : 1];

        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = selected.image;
        mainImage.alt = selected.alt;
        summaryImage.removeAttribute('srcset');
        summaryImage.removeAttribute('sizes');
        summaryImage.src = selected.image;
        this.querySelector(`[data-selected-name="${group}"]`).textContent = selected.name;
        this.querySelector(`[data-summary-name="${group}"]`).textContent = selected.name;
        this.querySelector(`[data-summary-price="${group}"]`).textContent = this.formatMoney(selected.price);
        const summaryMrp = this.querySelector(`[data-summary-mrp="${group}"]`);
        summaryMrp.textContent = `${this.dataset.mrpLabel} ${this.formatMoney(selected.compareAt)}`;
        summaryMrp.hidden = selected.compareAt <= selected.price;

        card.classList.remove('is-changing');
        requestAnimationFrame(() => card.classList.add('is-changing'));
        this.updatePricing();
      }

      updatePricing() {
        if (!this.state.one || !this.state.two) return;
        const currentTotal = this.state.one.price + this.state.two.price;
        const mrpTotal = Math.max(this.state.one.compareAt, this.state.one.price)
          + Math.max(this.state.two.compareAt, this.state.two.price);
        const bundlePrice = Math.round(currentTotal * (100 - this.discount) / 100);
        const saving = currentTotal - bundlePrice;
        const bundlePriceNode = this.querySelector('[data-bundle-price]');
        const currentTotalNode = this.querySelector('[data-current-total]');
        const mrpTotalNode = this.querySelector('[data-mrp-total]');
        const buttonPriceNode = this.querySelector('[data-button-price]');
        const savingNode = this.querySelector('[data-saving-text]');

        if (bundlePriceNode) bundlePriceNode.textContent = this.formatMoney(bundlePrice);
        if (currentTotalNode) {
          currentTotalNode.textContent = `${this.dataset.currentLabel} ${this.formatMoney(currentTotal)}`;
        }
        if (mrpTotalNode) {
          mrpTotalNode.textContent = `${this.dataset.mrpLabel} ${this.formatMoney(mrpTotal)}`;
          mrpTotalNode.hidden = mrpTotal <= currentTotal;
        }
        if (buttonPriceNode) buttonPriceNode.textContent = this.formatMoney(bundlePrice);
        if (savingNode) {
          savingNode.textContent = `${this.dataset.savingPrefix} ${this.formatMoney(saving)}`;
        }
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            maximumFractionDigits: 0
          }).format(cents / 100);
        } catch (error) {
          return `₹${Math.round(cents / 100).toLocaleString('en-IN')}`;
        }
      }

      async addBundle() {
        if (!this.state.one || !this.state.two || this.classList.contains('is-loading')) return;

        this.classList.add('is-loading');
        this.classList.remove('is-added');
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.addText.textContent = this.dataset.addingLabel;
        this.status.textContent = '';
        this.status.removeAttribute('role');
        this.viewCart.hidden = true;

        const cartUi = document.querySelector('cart-drawer, cart-notification');
        const sections = typeof cartUi?.getSectionsToRender === 'function'
          ? cartUi.getSectionsToRender().map((section) => section.id)
          : ['cart-drawer', 'cart-icon-bubble'];
        const bundleId = `${this.dataset.sectionId}-${Date.now()}`;
        const properties = {
          _bundle_id: bundleId,
          _bundle_name: this.dataset.bundleName
        };

        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: this.state.one.variantId,
                  quantity: 1,
                  properties: { ...properties, _bundle_item: '1' }
                },
                {
                  id: this.state.two.variantId,
                  quantity: 1,
                  properties: { ...properties, _bundle_item: '2' }
                }
              ],
              sections,
              sections_url: window.location.pathname
            })
          });

          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || this.dataset.errorLabel);

          if (typeof cartUi?.renderContents === 'function') cartUi.renderContents(payload);
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: payload, source: 'bundle-builder' }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          this.classList.remove('is-loading');
          this.classList.add('is-added');
          this.addText.textContent = this.dataset.addedLabel;
          this.addButton.removeAttribute('aria-busy');

          if (this.dataset.cartAction === 'cart') {
            window.location.assign(this.dataset.cartUrl);
            return;
          }

          this.status.textContent = `${this.state.one.name} + ${this.state.two.name}`;
          this.viewCart.hidden = false;
        } catch (error) {
          this.classList.remove('is-loading');
          this.addButton.disabled = false;
          this.addButton.removeAttribute('aria-busy');
          this.addText.textContent = this.dataset.addLabel;
          this.status.setAttribute('role', 'alert');
          this.status.textContent = error.message || this.dataset.errorLabel;
        }
      }

      resetAddedState() {
        this.classList.remove('is-added');
        this.addButton.disabled = false;
        this.addButton.removeAttribute('aria-busy');
        this.addText.textContent = this.dataset.addLabel;
        this.status.textContent = '';
        this.status.removeAttribute('role');
        this.viewCart.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1219-diwali-gifts"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('avenue-diwali-gifts')) {
  customElements.define('avenue-diwali-gifts', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.q = selector => this.querySelector(selector);
      this.config = JSON.parse(this.q('[data-config]').textContent);
      this.products = JSON.parse(this.q('[data-products]').textContent);
      this.form = this.q('[data-gift-form]');
      if (!this.form || !this.products.length) return;
      this.current = this.products.find(p => p.id === this.config.initial) || this.products[0];
      this.extras = [...this.querySelectorAll('[data-addon]')].map(card => ({
        ...JSON.parse(card.querySelector('[data-extra-data]').textContent), card
      }));
      this.selected = new Set();
      this.busy = false;
      this.needsReview = false;
      this.justAdded = false;
      try {
        this.formatter = new Intl.NumberFormat(this.config.locale || 'en-IN', {style:'currency',currency:this.config.currency});
      } catch (_) {
        this.formatter = new Intl.NumberFormat('en-IN', {style:'currency',currency:'INR'});
      }
      this.onClick = event => {
        if (this.busy || this.needsReview) return;
        const tile = event.target.closest('[data-hamper]');
        if (tile && this.contains(tile)) {
          const product = this.products.find(p => p.id === tile.dataset.hamper);
          if (!product) return;
          event.preventDefault();
          event.stopPropagation();
          this.current = product;
          this.selected.delete(product.id);
          this.update(true);
          return;
        }
        const button = event.target.closest('[data-extra-toggle]');
        if (button && this.contains(button) && !button.disabled) {
          event.preventDefault();
          event.stopPropagation();
          const id = button.closest('[data-addon]').dataset.addon;
          if (this.selected.has(id)) this.selected.delete(id);
          else this.selected.add(id);
          this.update(false);
        }
      };
      this.onChange = event => {
        const select = event.target.closest('[data-extra-variant]');
        if (!select || !this.contains(select) || this.busy || this.needsReview) return;
        const extra = this.extras.find(item => item.card === select.closest('[data-addon]'));
        const variant = extra?.variants.find(item => item.id === select.value);
        if (!variant) return;
        extra.variant = variant.id;
        extra.price = variant.price;
        extra.available = variant.available && variant.allowed;
        extra.allowed = variant.allowed;
        if (!extra.available) this.selected.delete(extra.product);
        this.update(false);
      };
      this.onSubmit = event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addToCart();
      };
      this.onBuyClick = event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addToCart();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.q('[data-submit]').addEventListener('click', this.onBuyClick, true);
      this.update(false);
      this.updateDelivery();
      if (this.config.cutoff) this.deliveryTimer = setInterval(() => this.updateDelivery(), 60000);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit, true);
      this.q('[data-submit]')?.removeEventListener('click', this.onBuyClick, true);
      clearInterval(this.deliveryTimer);
      clearTimeout(this.successTimer);
      this.ready = false;
    }
    money(value) { return this.formatter.format(Number(value) / 100); }
    cartItems() {
      return [{id:this.current.variant,quantity:1}, ...this.extras
        .filter(extra => this.selected.has(extra.product) && extra.available && extra.product !== this.current.id)
        .map(extra => ({id:extra.variant,quantity:1}))];
    }
    syncCartFields() {
      const host = this.q('[data-cart-extras]');
      host.replaceChildren();
      this.cartItems().slice(1).forEach((item, index) => {
        for (const key of ['id', 'quantity']) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'items[' + (index + 1) + '][' + key + ']';
          input.value = String(item[key]);
          host.append(input);
        }
      });
    }
    updateDelivery() {
      const title = this.q('[data-delivery-title]');
      if (!title) return;
      const deadline = Date.parse(this.config.cutoff);
      title.textContent = Number.isFinite(deadline) && deadline > Date.now() ? this.config.delivery : this.config.priority;
    }
    update(imageChanged) {
      const p = this.current, copy = this.config.copy;
      this.q('[data-product-title]').textContent = p.title;
      this.querySelectorAll('[data-product-link]').forEach(a => a.href = p.url);
      this.q('[data-variant-id]').value = p.variant;
      this.q('[data-price]').textContent = this.money(p.price);
      const sale = p.compare > p.price;
      this.q('[data-compare]').hidden = !sale;
      this.q('[data-compare]').textContent = this.money(p.compare);
      this.q('[data-discount]').hidden = !sale;
      this.q('[data-discount]').textContent = sale ? Math.round((p.compare - p.price) * 100 / p.compare) + '% ' + copy.off : '';
      if (imageChanged) {
        const hero = this.q('[data-hero]');
        hero.hidden = !p.image;
        this.q('[data-placeholder]').hidden = Boolean(p.image);
        if (p.image) {
          const imageUrl = width => {
            const url = new URL(p.image, window.location.origin);
            url.searchParams.set('width', String(width));
            return url.href;
          };
          hero.width = p.width;
          hero.height = p.height;
          hero.alt = p.alt || p.title;
          hero.loading = 'eager';
          hero.setAttribute('sizes', '(min-width: 990px) 550px, (min-width: 750px) 48vw, 94vw');
          hero.srcset = [360,540,720,960,1200].map(w => imageUrl(w) + ' ' + w + 'w').join(', ');
          hero.src = p.image;
        } else {
          hero.removeAttribute('srcset');
          hero.removeAttribute('src');
        }
      }
      const additions = this.extras.filter(e => this.selected.has(e.product) && e.available && e.product !== p.id);
      const total = p.price + additions.reduce((sum, e) => sum + e.price, 0);
      this.q('[data-summary]').textContent = p.title;
      this.q('[data-extras-summary]').textContent = additions.length ? copy.oneSet + ' + ' + additions.map(e => e.title).join(' + ') : copy.noExtras;
      this.q('[data-total]').textContent = this.money(total);
      this.q('[data-button-total]').textContent = this.money(total);
      this.querySelectorAll('[data-hamper]').forEach(b => {
        b.disabled = this.busy || this.needsReview;
        b.setAttribute('aria-pressed', String(b.dataset.hamper === p.id));
      });
      this.extras.forEach(extra => {
        const button = extra.card.querySelector('[data-extra-toggle]');
        const selected = this.selected.has(extra.product), same = extra.product === p.id;
        const included = extra.includedIn.includes(p.id);
        button.disabled = this.busy || this.needsReview || !extra.available || same || !p.available;
        button.setAttribute('aria-pressed', String(selected));
        button.textContent = same ? copy.same : !extra.allowed ? copy.unavailable : !extra.available ? copy.soldOut : selected ? copy.added : included ? copy.addExtra : copy.add;
        extra.card.dataset.selected = String(selected);
        extra.card.querySelector('[data-extra-price]').textContent = '+ ' + this.money(extra.price);
        const select = extra.card.querySelector('[data-extra-variant]');
        if (select) select.disabled = this.busy || this.needsReview || same || !p.available;
        extra.card.querySelector('[data-included]').hidden = !included || same;
      });
      this.syncCartFields();
      const submit = this.q('[data-submit]');
      submit.disabled = this.busy || this.justAdded || this.needsReview || !p.available;
      submit.setAttribute('aria-busy', String(this.busy));
      this.q('[data-submit-text]').textContent = this.busy ? copy.adding : this.justAdded ? copy.cartAdded : this.needsReview ? copy.review : p.available ? this.config.buy : copy.soldOut;
    }
    async addToCart() {
      if (this.busy || this.justAdded || this.needsReview || !this.current.available) return;
      if (this.config.designMode) {
        this.q('[data-status]').textContent = this.config.copy.editor;
        return;
      }
      const items = this.cartItems();
      const payload = {items};
      if (document.getElementById('cart-icon-bubble')) payload.sections = ['cart-icon-bubble'];
      this.busy = true;
      this.q('[data-status]').textContent = this.config.copy.adding;
      this.q('[data-review]').hidden = true;
      this.update(false);
      try {
        const response = await fetch(this.config.addUrl, {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const detail = typeof result.description === 'string' ? result.description : '';
          throw new Error(detail);
        }
        const addedIds = new Set((Array.isArray(result.items) ? result.items : [result]).map(item => String(item.variant_id || item.id)));
        if (items.some(item => !addedIds.has(String(item.id)))) throw new Error(this.config.copy.incomplete);
        this.justAdded = true;
        this.q('[data-status]').textContent = this.config.copy.success;
        this.q('[data-review]').hidden = false;
        clearTimeout(this.successTimer);
        this.successTimer = setTimeout(() => {
          this.justAdded = false;
          if (this.isConnected) this.update(false);
        }, 1800);
        try {
          const bubble = document.getElementById('cart-icon-bubble');
          const html = result.sections?.['cart-icon-bubble'];
          if (bubble && typeof html === 'string') {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const content = parsed.querySelector('#shopify-section-cart-icon-bubble');
            if (content) bubble.innerHTML = content.innerHTML;
          }
        } catch (_) {}
      } catch (error) {
        this.needsReview = true;
        this.q('[data-status]').textContent = (error.message ? error.message + ' ' : '') + this.config.copy.error;
        this.q('[data-review]').hidden = false;
      } finally {
        this.busy = false;
        this.update(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1219-product-studio-single"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__avenueStudioSingleV1) return;
  window.__avenueStudioSingleV1 = true;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const normalize = value => String(value || '').trim().toLowerCase();
  const personalized = item => /personalized|personalised|customized|customised/i.test(item.title || '');
  const tagged = (item, tag) => (item.tags || []).includes(tag);
  const compact = item => ({id:item.id,url:item.url,title:item.title,label:item.label,tags:item.tags,available:item.available,image:item.image,price:item.price,railOptions:item.railOptions});
  class AvenueStudio {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-av-config]').textContent);
      this.initial = JSON.parse(root.querySelector('[data-av-initial]').textContent);
      this.current = this.initial;
      this.slots = [this.current];
      this.active = 0;
      this.quantity = this.current.variant?.min || 1;
      this.cache = new Map();
      this.excluded = new Set([...(this.config.excluded || []), ...(this.config.familyExcluded || [])].map(String));
      this.colorNames = [...new Set(['color','colour','colors','colours',...String(this.config.colorNames || '').split(',').map(normalize)])];
      this.swatches = new Map(String(this.config.swatches || '').split('\n').map(line => {
        const i = line.indexOf(':');
        return [normalize(line.slice(0,i)), line.slice(i+1).trim()];
      }));
      this.products = this.config.source === 'manual' ? this.filter(this.config.manual) : this.filter([compact(this.initial)]);
      this.next = this.config.source === 'collection' ? this.config.collection : null;
      this.loading = false;
      this.cartBusy = false;
      this.checkoutBusy = false;
      this.checkoutItems = null;
      this.uncertain = false;
      this.alive = true;
      this.currency = new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency});
      this.events = new AbortController();
      root.addEventListener('click', event => this.click(event), {signal:this.events.signal});
      root.addEventListener('change', event => this.change(event), {signal:this.events.signal});
      this.$('[data-av-cart]').addEventListener('click', event => {
        if (event.target === this.$('[data-av-cart]')) this.closeCart();
      }, {signal:this.events.signal});
      this.$('[data-av-cart]').addEventListener('close', () => {const target=this.lastFocus; this.lastFocus=null; target?.focus({preventScroll:true});}, {signal:this.events.signal});
      this.render();
      this.renderRail();
      if (this.next) this.loadMore(true);
      const dock = this.$('[data-av-sticky]');
      if (dock && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {dock.hidden = entries[0].isIntersecting;}, {threshold:0});
        this.observer.observe(this.$('[data-av-main-actions]'));
      } else if (dock) dock.hidden = false;
      this.offerTimer = setInterval(() => this.renderOffer(), 30000);
    }
    $(selector) {return this.root.querySelector(selector);}
    $$(selector) {return [...this.root.querySelectorAll(selector)];}
    t(key, values = {}) {
      let value = this.config.strings[key] || key;
      for (const [name, replacement] of Object.entries(values)) value = value.replaceAll(`[${name}]`, String(replacement));
      return value;
    }
    money(amount, currency) {
      return currency && currency !== this.config.currency ? new Intl.NumberFormat(this.config.locale,{style:'currency',currency}).format(Number(amount)/100) : this.currency.format(Number(amount)/100);
    }
    url(path) {
      const url = new URL(path, location.origin);
      if (url.origin !== location.origin) throw new Error(this.t('product_error'));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    }
    async get(url, json = false) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, {credentials:'same-origin', signal:controller.signal, headers:{Accept:json?'application/json':'text/html'}});
        if (!response.ok) throw new Error(this.t('product_error'));
        return json ? await response.json() : await response.text();
      } finally {clearTimeout(timer);}
    }
    payload(html) {
      const doc = new DOMParser().parseFromString(html,'text/html');
      const node = doc.querySelector('[data-av-payload]');
      if (!node) throw new Error(this.t('product_error'));
      return JSON.parse(node.textContent);
    }
    async product(path, optionIds = []) {
      const url = this.url(path);
      url.searchParams.delete('variant');
      url.searchParams.delete('option_values');
      url.searchParams.set('section_id','1219-product-studio-single');
      if (optionIds.length) url.searchParams.set('option_values',optionIds.join(','));
      const key = url.href;
      if (this.cache.has(key)) return this.cache.get(key);
      const data = this.payload(await this.get(key)).product;
      if (!data?.id) throw new Error(this.t('product_error'));
      if (this.cache.size >= 40) this.cache.delete(this.cache.keys().next().value);
      this.cache.set(key,data);
      return data;
    }
    filter(items) {
      return (items || []).filter(item => !this.excluded.has(String(item.id)) && !(this.config.excludeNoCod && tagged(item,'no-cod')) && !(this.config.excludePersonalized && personalized(item)) && !(this.config.hideSoldOut && !item.available));
    }
    async loadMore(first = false) {
      if (!this.next || this.railBusy) return;
      this.railBusy = true;
      this.$('[data-av-more]').disabled = true;
      this.$('[data-av-rail-status]').textContent = this.t('loading');
      try {
        const url = this.url(this.next);
        url.searchParams.set('section_id','1219-product-studio-single');
        const data = this.payload(await this.get(url.href));
        if (!this.alive) return;
        const all = first ? data.products : [...this.products,...data.products];
        this.products = this.filter([...new Map(all.map(item => [String(item.id),item])).values()]);
        this.next = data.next || null;
        this.renderRail();
      } catch (error) {
        this.$('[data-av-rail-status]').textContent = this.t('load_error');
        this.$('[data-av-more]').hidden = false;
      } finally {
        this.railBusy = false;
        this.$('[data-av-more]').disabled = false;
      }
    }
    printName(item) {
      if (item.label && item.label !== item.title) return item.label;
      const title = String(item.title || '').trim();
      const parts = title.split(/\s*\|\s*/).filter(Boolean);
      const chosen = Number(this.config.railLabelPart) || 0;
      if (chosen && parts[chosen-1]) return parts[chosen-1];
      const spec = value => /(?:\d+\s*(?:ml|ltr?|litres?|liters?|hours?|hrs?|oz)\b|\d+\s*%|leak[ -]?proof|double[ -]?wall|insulat|colou?rs?\s*options?|hot\s*(?:&|and)\s*cold)/i.test(value);
      if (parts.length > 1) return parts.slice(1).find(part => !spec(part)) || this.config.railPlainLabel || 'Classic';
      const dashParts = title.split(/\s+[—–-]\s+/).filter(Boolean);
      return dashParts.length > 1 ? dashParts[dashParts.length-1] : title;
    }
    optionKey(name) {return this.colorNames.includes(normalize(name)) ? '__color__' : normalize(name);}
    valueKey(name,value) {return this.optionKey(name)==='__color__' ? normalize(value).replace(/[\s_-]+/g,'') : normalize(value);}
    selectedColor() {
      if (this.config.railSync === false) return null;
      const option = this.current.options.find(option => this.optionKey(option.name)==='__color__');
      return option?.values.find(value => value.selected)?.name || null;
    }
    railPreview(item) {
      const color = this.selectedColor();
      const options = item.railOptions || [];
      const option = options.find(option => this.optionKey(option.name)==='__color__');
      if (!color || !option) return {image:item.image,note:''};
      const value = option.values.find(value => this.valueKey(option.name,value.name)===this.valueKey(option.name,color));
      if (!value) return {image:null,note:this.t('rail_color_missing',{color})};
      return {image:value.image,note:value.image?'':this.t('rail_photo_missing')};
    }
    updateRail() {
      const currentIndex = this.products.findIndex(item => String(item.id)===String(this.current.id));
      if (currentIndex !== -1) this.products[currentIndex]=compact(this.current);
      const color = this.selectedColor();
      const resolution = Math.max(360,Math.min(960,Number(this.config.railResolution) || 720));
      const sizes = `(max-width: 749px) ${Number(this.config.railMobile)||72}px, ${Number(this.config.railDesktop)||88}px`;
      const nodes = new Map(this.$$('[data-av-design]').map(node => [node.dataset.avDesign,node]));
      this.products.forEach(item => {
        const node = nodes.get(String(item.id));
        if (!node) return;
        const label = this.printName(item);
        const colorLabel = (item.railOptions || []).some(option => this.optionKey(option.name)==='__color__') ? color : null;
        const preview = this.railPreview(item);
        const note = preview.note || (!item.available ? this.t('sold_out') : '');
        const image = node.querySelector('img');
        node.setAttribute('aria-pressed',String(item.id)===String(this.current.id)?'true':'false');
        node.setAttribute('aria-label',[label,colorLabel,note].filter(Boolean).join(' · '));
        node.title = [label,note].filter(Boolean).join(' · ');
        node.querySelector('.av-design-label').textContent=label;
        const detail = node.querySelector('[data-av-rail-note]');
        detail.textContent=note;
        detail.hidden=!note;
        image.hidden=!preview.image;
        node.querySelector('.av-design-placeholder').hidden=!!preview.image;
        if (preview.image) {
          const src=this.imageUrl(preview.image,resolution);
          const srcset=[180,240,360,540,720,960].filter(width => width<=resolution).map(width => `${this.imageUrl(preview.image,width)} ${width}w`).join(',');
          if (image.sizes!==sizes) image.sizes=sizes;
          if (image.srcset!==srcset) image.srcset=srcset;
          if (image.getAttribute('src')!==src) image.src=src;
          image.alt=[label,colorLabel].filter(Boolean).join(' · ');
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('src');
          image.alt='';
        }
      });
    }
    renderRail() {
      const rail = this.$('[data-av-rail]');
      const offset = rail.scrollLeft;
      const nodes = new Map(this.$$('[data-av-design]').map(node => [node.dataset.avDesign,node]));
      const allowed = new Set(this.products.map(item => String(item.id)));
      nodes.forEach((node,id) => {if (!allowed.has(id)) node.remove();});
      this.products.forEach(item => {
        if (!nodes.has(String(item.id))) rail.insertAdjacentHTML('beforeend',`<button type="button" class="av-design" data-av-design="${esc(item.id)}"><span class="av-design-media"><img width="360" height="450" loading="lazy" decoding="async" alt="" hidden><span class="av-design-placeholder" aria-hidden="true">◇</span></span><span class="av-design-label"></span><small data-av-rail-note hidden></small></button>`);
      });
      this.updateRail();
      rail.scrollLeft = offset;
      this.$('[data-av-more]').hidden = !this.next;
      this.$('[data-av-rail-status]').textContent = !this.products.length ? this.t('no_designs') : this.next ? this.t('remaining') : '';
      this.renderActions();
    }
    selectedValues(product = this.current) {return product.options.map(option => option.values.find(value => value.selected) || option.values[0]);}
    async switchProduct(path) {
      if (this.loading || this.cartBusy || this.checkoutBusy) return;
      this.loading = true;
      this.message(this.t('loading'));
      this.renderActions();
      try {
        const old = new Map(this.current.options.map(option => [this.optionKey(option.name),this.valueKey(option.name,option.values.find(value => value.selected)?.name)]));
        let data = await this.product(path);
        const wanted = data.options.map(option => option.values.find(value => this.valueKey(option.name,value.name) === old.get(this.optionKey(option.name))) || option.values.find(value => value.selected) || option.values[0]);
        if (wanted.some(value => !value.selected)) data = await this.product(data.url,wanted.map(value => value.id));
        if (!this.alive) return;
        if (this.filter([compact(data)]).length === 0) throw new Error(this.t('unavailable'));
        this.current = data;
        this.slots[this.active] = data;
        this.quantity = Math.max(this.quantity, data.variant?.min || 1);
        this.message('');
        this.render();
        this.renderRail();
      } catch (error) {this.message(error.message || this.t('product_error'),true);}
      finally {this.loading = false; if(this.alive) this.renderActions();}
    }
    async switchOption(id, position) {
      if (this.loading || this.cartBusy || this.checkoutBusy) return;
      const option = this.current.options.find(item => item.position === position);
      const value = option?.values.find(item => item.id === id);
      if (!value) return;
      if (value.productUrl && this.url(value.productUrl).pathname !== this.url(this.current.url).pathname) {
        await this.switchProduct(value.productUrl);
        return;
      }
      const selected = this.selectedValues().map((item,index) => index===position-1 ? id : item.id);
      this.loading = true;
      this.renderActions();
      this.message(this.t('loading'));
      try {
        const data = await this.product(this.current.url,selected);
        if (!this.alive) return;
        this.current = data;
        this.slots[this.active] = data;
        this.message('');
        this.render(true);
        this.updateRail();
      } catch (error) {this.message(this.t('product_error'),true);}
      finally {this.loading = false; if(this.alive) {this.renderActions(); this.$(`[data-av-option="${CSS.escape(id)}"]`)?.focus({preventScroll:true});}}
    }
    imageUrl(url, width) {
      const parsed = new URL(url,location.origin);
      if (!['https:','http:'].includes(parsed.protocol)) return '';
      parsed.searchParams.set('width',String(width));
      return parsed.href;
    }
    setImage(node,url,alt,priority = false) {
      if (!node || !url) return;
      const width = priority ? 1400 : 900;
      if (node.getAttribute('src') !== url) node.src = url;
      node.srcset = [400,600,900,width].filter((v,i,a)=>a.indexOf(v)===i).map(size => `${this.imageUrl(url,size)} ${size}w`).join(',');
      node.sizes = '(min-width: 1000px) 50vw, 100vw';
      node.alt = alt || '';
      node.width = width;
      node.height = width;
      node.loading = priority ? 'eager' : 'lazy';
      node.decoding = 'async';
      if (priority) node.fetchPriority = 'high';
    }
    renderGallery() {
      const gallery = this.$('[data-av-hero]');
      let img = gallery.querySelector('img');
      if (!img && this.current.hero) {img = document.createElement('img'); gallery.append(img);}
      if (img) {img.hidden = !this.current.hero; this.setImage(img,this.current.hero,this.current.title,true);}
      this.photos = this.current.images || [];
      this.$('[data-av-thumbs]').innerHTML = this.photos.map((photo,index) => `<button type="button" data-av-photo="${index}" aria-label="${esc(photo.alt || this.current.title)}" aria-pressed="${photo.url===this.current.hero}"><img src="${esc(this.imageUrl(photo.url,160))}" width="80" height="80" alt="${esc(photo.alt || this.current.title)}" loading="lazy" decoding="async"></button>`).join('');
    }
    renderOptions() {
      this.$('[data-av-options]').innerHTML = this.current.defaultOnly ? '' : this.current.options.map(option => {
        const isColor = this.colorNames.includes(normalize(option.name));
        const selected = option.values.find(value => value.selected);
        return `<fieldset><legend>${esc(option.name)} <b>${esc(selected?.name || '')}</b></legend><div class="av-values">${option.values.map(value => {
          let color = value.swatch || this.swatches.get(normalize(value.name));
          color = color && CSS.supports('color',color) ? color : null;
          const swatch = isColor && (value.swatchImage || color);
          const inside = value.swatchImage ? `<img src="${esc(value.swatchImage)}" width="30" height="30" alt="">` : `<span style="background-color:${esc(color)}"></span>`;
          return `<button type="button" class="av-option${swatch?' av-swatch':''}${!value.available?' av-unavailable':''}" data-av-option="${esc(value.id)}" data-position="${option.position}" aria-pressed="${!!value.selected}" title="${esc(value.name)}" aria-label="${esc(value.name)}${!value.available?' · '+esc(this.t('sold_out')):''}">${swatch ? inside : esc(value.name)}</button>`;
        }).join('')}</div></fieldset>`;
      }).join('');
    }
    richText(html) {
      const doc = new DOMParser().parseFromString(String(html || ''),'text/html');
      doc.querySelectorAll('script,style,iframe,object,embed,form,link,meta,base').forEach(node=>node.remove());
      doc.body.querySelectorAll('*').forEach(node => [...node.attributes].forEach(attribute => {
        if (/^on/i.test(attribute.name) || (['href','src','action'].includes(attribute.name) && /^\s*(javascript|data):/i.test(attribute.value))) node.removeAttribute(attribute.name);
      }));
      return doc.body.innerHTML;
    }
    details() {
      const value = this.current.details || this.config.familyDetails;
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    }
    renderDetails() {
      const mode = this.current.descriptionMode || this.config.descriptionMode;
      const common = this.current.commonDescription || this.config.familyDescription || this.config.commonDescription;
      this.$('[data-av-description]').innerHTML = this.richText(mode==='common' && common ? common : this.current.description);
      const details = this.details();
      this.$('[data-av-why-heading]').textContent = details.whyTitle || this.config.whyTitle;
      this.$('[data-av-caption]').textContent = details.caption || this.config.caption;
      const photo = this.$('.av-editorial-image');
      this.setImage(photo,this.config.editorialImage || this.current.hero,this.current.title);
      const benefits = Array.isArray(details.benefits) ? details.benefits.slice(0,3) : this.config.benefits;
      this.$('[data-av-benefits]').innerHTML = benefits.map(benefit => `<article class="av-benefit" ${this.config.benefits.includes(benefit)?benefit.attributes||'':''}><span class="av-eyebrow">${esc(benefit.eyebrow)}</span><h3>${esc(benefit.heading)}</h3><div class="av-benefit-values">${benefit.value?`<strong>${esc(benefit.value)}</strong>`:''}${benefit.secondValue?`<strong>${esc(benefit.secondValue)}</strong>`:''}</div><p>${esc(benefit.text)}</p></article>`).join('');
      const standards = Array.isArray(details.standards) ? details.standards : this.config.standards;
      const applicable = standards.filter(standard => standard.enabled !== false && (!standard.tag || tagged(this.current,standard.tag)));
      this.$('[data-av-standards]').hidden = !applicable.length;
      this.$('.av-assurance-grid').classList.toggle('av-no-standards',!applicable.length);
      this.$('[data-av-standards]').innerHTML = applicable.map(standard => {
        let link = '';
        try {const url = new URL(standard.link,location.origin); if (standard.link && ['https:','http:'].includes(url.protocol)) link=url.href;} catch (_) {}
        return `<div class="av-standard" ${this.config.standards.includes(standard)?standard.attributes||'':''}><span class="av-mark">${esc(standard.mark)}</span><div><strong>${link?`<a href="${esc(link)}">${esc(standard.heading)}</a>`:esc(standard.heading)}</strong><p>${esc(standard.text)}</p></div></div>`;
      }).join('');
    }
    renderOffer() {
      const offer = this.config.offer;
      const now = Date.now();
      const start = offer.start ? Date.parse(offer.start) : -Infinity;
      const end = offer.end ? Date.parse(offer.end) : Infinity;
      const eligible = this.slots.every(item => !tagged(item,'no-cod') && !personalized(item));
      this.$('[data-av-offer]').hidden = !(offer.enabled && offer.code && eligible && now>=start && now<=end);
    }
    renderBundles() {
      if (!this.config.bundles) return;
      const count = this.slots.length;
      this.$('[data-av-tiers]').innerHTML = [1,2,3].map(n => {
        const percent = n===2 ? this.config.discountTwo : n===3 ? this.config.discountThree : 0;
        return `<button type="button" data-av-tier="${n}" aria-pressed="${count===n}"><b>${esc(this.t('buy_count',{count:n}))}</b><span>${esc(percent && this.config.discountsReady ? this.t('bundle_offer',{percent}) : this.t('no_offer'))}</span></button>`;
      }).join('');
      this.$('[data-av-slots]').innerHTML = count>1 ? this.slots.map((item,index) => `<button type="button" data-av-slot="${index}" aria-pressed="${this.active===index}"><b>${esc(this.t('piece',{count:index+1}))}</b><span>${esc(item.label)}</span><small>${esc(item.defaultOnly?'':item.variant?.title || this.t('unavailable'))}</small></button>`).join('') : '';
      this.$('[data-av-bundle-hint]').hidden = count===1;
      this.$('[data-av-bundle-notice]').hidden = count===1;
      this.$('[data-av-editing]').hidden = count===1;
      this.$('[data-av-editing]').textContent = this.t('editing_piece',{count:this.active+1});
    }
    items() {
      const map = new Map();
      this.slots.forEach(item => {
        if (!item.variant) return;
        const id = item.variant.id;
        const quantity = this.slots.length===1 ? this.quantity : 1;
        map.set(id,{id,quantity:(map.get(id)?.quantity || 0)+quantity});
      });
      return [...map.values()];
    }
    purchaseError() {
      if (this.slots.some(item=>item.requiresSellingPlan)) return this.t('subscription');
      if (this.slots.some(item=>!item.variant)) return this.t('unavailable');
      if (this.slots.some(item=>!item.variant.available)) return this.t(this.slots.length>1?'bundle_unavailable':'out_of_stock');
      for (const line of this.items()) {
        const variant = this.slots.find(item=>item.variant?.id===line.id).variant;
        const min = variant.min || 1, step=variant.step || 1;
        if (!Number.isInteger(line.quantity) || line.quantity<min || line.quantity%step!==0 || (variant.max && line.quantity>variant.max)) return this.t('quantity_rule',{min,step});
      }
      return '';
    }
    total() {return this.slots.reduce((sum,item)=>sum+(item.variant?.price || 0),0)*(this.slots.length===1?this.quantity:1);}
    renderTotals() {
      const amount = this.slots.some(item=>!item.variant) ? '—' : this.money(this.total());
      this.$('[data-av-total]').textContent = amount;
      if (this.$('[data-av-sticky-price]')) this.$('[data-av-sticky-price]').textContent = amount;
      const quantity = this.$('[data-av-quantity]');
      quantity.min = this.current.variant?.min || 1;
      quantity.step = this.current.variant?.step || 1;
      if(this.current.variant?.max) quantity.max=this.current.variant.max; else quantity.removeAttribute('max');
      quantity.value = String(this.quantity);
      this.$('[data-av-quantity-wrap]').hidden = this.slots.length>1;
    }
    renderActions() {
      const error = this.purchaseError();
      const busy = this.loading || this.cartBusy || this.checkoutBusy;
      if(this.checkoutItems && this.checkoutItems!==JSON.stringify(this.items())) this.checkoutItems=null;
      this.root.setAttribute('aria-busy',String(busy));
      this.$$('[data-av-add],[data-av-buy]').forEach(button => {
        button.disabled = !!(error || busy || this.uncertain);
        const label = button.hasAttribute('data-av-add')?'add':this.checkoutItems?'continue_checkout':'buy';
        button.textContent = busy ? this.t('loading') : this.current.variant && !this.current.variant.available ? this.t('sold_out') : this.t(label);
        button.title = error || '';
      });
      this.$$('[data-av-option],[data-av-design],[data-av-tier],[data-av-slot],[data-av-quantity]').forEach(element=>{element.disabled=busy;});
      this.$('[data-av-checkout]').disabled=!!(busy || !this.cart?.items?.length);
      if (error && !busy) this.message(error,true);
    }
    render(variantOnly = false) {
      this.$('[data-av-title]').textContent = this.current.title;
      this.$('[data-av-price]').textContent = this.current.variant ? this.money(this.current.variant.price) : '—';
      const compare = this.$('[data-av-compare]');
      compare.hidden = !(this.current.variant?.compare > this.current.variant?.price);
      compare.textContent = this.current.variant?.compare ? this.money(this.current.variant.compare) : '';
      this.$('[data-av-product-link]').href = this.current.url + (this.current.variant ? `?variant=${this.current.variant.id}` : '');
      this.$$('[data-av-related]').forEach(card=>{card.hidden = card.dataset.avRelated===String(this.current.id);});
      this.renderGallery();
      this.renderOptions();
      if (!variantOnly) this.renderDetails();
      else this.setImage(this.$('.av-editorial-image'),this.config.editorialImage || this.current.hero,this.current.title);
      this.renderBundles();
      this.renderOffer();
      this.renderTotals();
      this.renderActions();
    }
    message(text,error = false) {
      const node = this.$('[data-av-message]');
      node.textContent = text;
      node.hidden = !text;
      node.classList.toggle('av-error',error);
    }
    async click(event) {
      const button = event.target.closest('button');
      if (!button || !this.root.contains(button)) return;
      if(button.matches('[data-av-add],[data-av-buy],[data-av-checkout]')) {event.preventDefault(); event.stopPropagation();}
      if (button.hasAttribute('data-av-design')) {
        const item = this.products.find(item=>String(item.id)===button.dataset.avDesign);
        if(item) await this.switchProduct(item.url);
      } else if (button.hasAttribute('data-av-option')) await this.switchOption(button.dataset.avOption,Number(button.dataset.position));
      else if (button.hasAttribute('data-av-more')) await this.loadMore();
      else if (button.hasAttribute('data-av-scroll')) this.$('[data-av-rail]').scrollBy({left:Number(button.dataset.avScroll)*this.$('[data-av-rail]').clientWidth*0.75,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      else if (button.hasAttribute('data-av-photo')) {
        const photo = this.photos[Number(button.dataset.avPhoto)];
        if(photo) {this.setImage(this.$('[data-av-hero] img'),photo.url,photo.alt,true); this.$$('[data-av-photo]').forEach(node=>node.setAttribute('aria-pressed',String(node===button)));}
      } else if (button.hasAttribute('data-av-tier')) {
        if(this.loading || this.cartBusy || this.checkoutBusy) return;
        const count = Number(button.dataset.avTier);
        this.slots = Array.from({length:count},(_,index)=>this.slots[index] || this.current);
        this.active = 0;
        this.current = this.slots[0];
        this.message(''); this.render(); this.renderRail();
      } else if (button.hasAttribute('data-av-slot')) {
        if(this.loading || this.cartBusy || this.checkoutBusy) return;
        this.active=Number(button.dataset.avSlot); this.current=this.slots[this.active];
        this.message(''); this.render(); this.renderRail();
      } else if (button.hasAttribute('data-av-copy')) {
        try {await navigator.clipboard.writeText(this.config.offer.code); button.querySelector('span').textContent=this.t('copied');}
        catch (_) {this.message(this.t('copy_error')); const range=document.createRange(); range.selectNodeContents(button.querySelector('b')); const selection=window.getSelection(); selection.removeAllRanges(); selection.addRange(range);}
      } else if (button.hasAttribute('data-av-add')) await this.add(false);
      else if (button.hasAttribute('data-av-buy')) await this.add(true);
      else if (button.hasAttribute('data-av-close')) this.closeCart();
      else if (button.hasAttribute('data-av-checkout')) await this.checkout();
      else if (button.hasAttribute('data-av-remove')) await this.removeItem(button.dataset.avRemove);
    }
    change(event) {
      if(!event.target.matches('[data-av-quantity]') || this.cartBusy || this.checkoutBusy) return;
      this.quantity = Number(event.target.value);
      this.message(''); this.renderTotals(); this.renderActions();
    }
    async readCart() {return this.get(this.url(this.config.routes.cart+'.js').href,true);}
    async add(checkout) {
      if (this.cartBusy || this.checkoutBusy || this.loading || this.uncertain || this.purchaseError()) return;
      const selectedItems=JSON.stringify(this.items());
      if(checkout && this.checkoutItems===selectedItems) {await this.checkout(); return;}
      this.checkoutItems=null;
      this.cartBusy=true;
      this.message(this.t('loading_cart'));
      this.$('[data-av-cart-link]').hidden=true;
      this.renderActions();
      let added=false;
      try {
        const payload={items:this.items()};
        if (document.getElementById('cart-icon-bubble')) {payload.sections=['cart-icon-bubble']; payload.sections_url=location.pathname;}
        let response;
        try {response = await fetch(this.url(this.config.routes.add), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});}
        catch (_) {this.uncertain=true; throw new Error(this.t('cart_check'));}
        let data;
        try {data=await response.json();}
        catch (_) {this.uncertain=true; throw new Error(this.t('cart_check'));}
        if(!response.ok) {
          this.cache.clear();
          throw new Error((typeof data.description==='string'?data.description:this.t('cart_error'))+' '+this.t('view_cart'));
        }
        added=true;
        if(checkout) this.checkoutItems=selectedItems;
        this.cart=null;
        this.message(this.t('added'));
        this.updateIcon(data.sections);
        try {
          this.cart=await this.readCart();
          document.dispatchEvent(new CustomEvent('avenue:cart-updated',{detail:{cart:this.cart,source:this.root}}));
        } catch (_) {this.message(this.t('cart_load_error'));}
      } catch(error) {this.message(error.message || this.t('cart_error'),true);}
      finally {
        this.cartBusy=false;
        this.$('[data-av-cart-link]').hidden=false;
        this.renderActions();
        if(added) this.cache.clear();
        if(this.$('[data-av-cart]').open) this.renderCart();
      }
      if(!added || !this.alive) return;
      if(checkout) await this.checkout();
      else if(this.config.cartAction==='cart') location.assign(this.config.routes.cart);
      else if(this.config.cartAction==='drawer' && this.cart) this.openCart();
    }
    updateIcon(sections) {
      const html=sections?.['cart-icon-bubble'];
      const target=document.getElementById('cart-icon-bubble');
      if(!html || !target) return;
      const doc=new DOMParser().parseFromString(html,'text/html');
      const source=doc.querySelector('#cart-icon-bubble') || doc.querySelector('.shopify-section');
      if(source) target.innerHTML=source.innerHTML;
    }
    openCart() {
      const dialog=this.$('[data-av-cart]');
      this.lastFocus=document.activeElement;
      this.renderCart();
      if(!dialog.open) dialog.showModal();
    }
    closeCart(restoreFocus=true) {if(!restoreFocus) this.lastFocus=null; this.$('[data-av-cart]').close();}
    renderCart() {
      if(!this.cart) return;
      const items=this.cart.items || [];
      this.$('[data-av-cart-body]').innerHTML=items.length?items.map(item=>`<article class="av-cart-item">${item.image?`<img src="${esc(this.imageUrl(item.image,160))}" width="80" height="96" alt="${esc(item.product_title)}" loading="lazy">`:''}<div><a href="${esc(item.url)}">${esc(item.product_title)}</a><p>${esc(item.variant_title || '')}</p><p>${esc(this.t('quantity'))}: ${item.quantity}</p><strong>${esc(this.money(item.final_line_price,this.cart.currency))}</strong>${item.original_line_price>item.final_line_price?` <s>${esc(this.money(item.original_line_price,this.cart.currency))}</s>`:''}<button type="button" class="av-text-button" data-av-remove="${esc(item.key)}">${esc(this.t('remove'))}</button></div></article>`).join(''):`<p>${esc(this.t('empty_cart'))}</p>`;
      this.$('[data-av-cart-total]').textContent=this.money(this.cart.total_price,this.cart.currency);
      this.$('[data-av-checkout]').disabled=!items.length || this.cartBusy || this.checkoutBusy;
    }
    async removeItem(key) {
      if(this.cartBusy || this.checkoutBusy) return;
      this.checkoutItems=null;
      this.cartBusy=true;
      this.$$('[data-av-remove],[data-av-checkout]').forEach(button=>{button.disabled=true;});
      const message=this.$('[data-av-cart-message]'); message.hidden=true;
      try {
        const response=await fetch(this.url(this.config.routes.change),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})});
        const data=await response.json();
        if(!response.ok) throw new Error(this.t('cart_remove_error'));
        this.cart=data;
        document.dispatchEvent(new CustomEvent('avenue:cart-updated',{detail:{cart:this.cart,source:this.root}}));
        if(document.getElementById('cart-icon-bubble')) {
          try {const url=this.url(this.config.routes.cart); url.searchParams.set('sections','cart-icon-bubble'); this.updateIcon(await this.get(url.href,true));} catch (_) {}
        }
      } catch (_) {message.hidden=false; message.textContent=this.t('cart_remove_error');}
      finally {this.cartBusy=false; this.renderCart(); this.renderActions();}
    }
    async checkout() {
      if(this.checkoutBusy || this.cartBusy || !this.alive) return;
      if(this.config.checkoutMode==='shopify') {
        const root=this.config.routes.root.replace(/\/$/,'');
        location.assign(root+'/checkout');
        return;
      }
      if(this.config.checkoutMode==='gokwik') {
        this.checkoutBusy=true;
        this.renderActions();
        try {
          this.cart=await this.readCart();
          if(!this.alive) return;
          if(!this.cart.items?.length) {this.checkoutItems=null;throw new Error(this.t('empty_cart'));}
          if(this.checkoutItems && !JSON.parse(this.checkoutItems).every(wanted=>this.cart.items.reduce((sum,item)=>sum+(String(item.variant_id || item.id)===String(wanted.id)?Number(item.quantity):0),0)>=wanted.quantity)) {
            this.checkoutItems=null;
            throw new Error(this.t('cart_changed'));
          }
          const selector=String(this.config.checkoutSelector || '').trim();
          if(selector) {
            const trigger=[...document.querySelectorAll(selector)].find(element=>!element.closest('[data-av-single-root]') && element.matches('button,input[type="submit"],a') && !element.disabled && element.getAttribute('aria-disabled')!=='true' && !element.closest('form[action*="/cart/add"]') && element.name!=='add' && (element.dataset.gokwikFunction || element.dataset.function)!=='buyNow');
            if(!trigger) throw new Error(this.t('checkout_missing'));
            this.closeCart(false);
            trigger.click();
          } else {
            const sdk=await this.goKwikSdk();
            if(!this.alive) return;
            if(!sdk || !window.merchantInfo?.mid) throw new Error(this.t('checkout_missing'));
            this.closeCart(false);
            await sdk.initCheckout(window.merchantInfo);
          }
        } catch(error) {
          if(this.alive) {
            const message=error.message===this.t('empty_cart') || error.message===this.t('cart_changed') || error.message===this.t('checkout_missing')?error.message:this.t('checkout_error');
            this.message(message,true);
            if(this.$('[data-av-cart]').open) {const note=this.$('[data-av-cart-message]');note.textContent=message;note.hidden=false;}
          }
        } finally {
          this.checkoutBusy=false;
          if(this.alive) {this.$('[data-av-cart-link]').hidden=false;this.renderActions();}
        }
        return;
      }
      location.assign(this.config.routes.cart);
    }
    async goKwikSdk() {
      const ready=()=>typeof window.gokwikSdk?.initCheckout==='function'?window.gokwikSdk:null;
      if(ready()) return ready();
      await new Promise(resolve=>{
        let timer;
        const finish=()=>{clearTimeout(timer);window.removeEventListener('gokwikLoaded',finish);this.events.signal.removeEventListener('abort',finish);resolve();};
        window.addEventListener('gokwikLoaded',finish,{once:true});
        this.events.signal.addEventListener('abort',finish,{once:true});
        timer=setTimeout(finish,4000);
        if(ready() || !this.alive) finish();
      });
      return ready();
    }
    destroy() {
      this.alive=false;
      this.events.abort();
      this.observer?.disconnect();
      clearInterval(this.offerTimer);
      this.closeCart();
      this.root._avenueStudio=null;
    }
  }
  const init = scope => scope.querySelectorAll('[data-av-single-root]').forEach(root=>{
    if(root._avenueStudio || !root.querySelector('[data-av-config]')) return;
    try {root._avenueStudio=new AvenueStudio(root);} catch (error) {const message=root.querySelector('[data-av-message]'); if(message){message.hidden=false; message.textContent=JSON.parse(root.querySelector('[data-av-config]').textContent).strings.init_error;}}
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true}); else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-av-single-root]').forEach(root=>root._avenueStudio?.destroy()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
